import {
  type ActiveInterrupt,
  ActiveInterruptSchema,
  type ActiveSessionSkillsResponse,
  ActiveSessionSkillsResponseSchema,
  type AdminAttachmentBySession,
  type AdminAttachmentBySessionQuery,
  AdminAttachmentBySessionSchema,
  type AdminBranding,
  AdminBrandingSchema,
  type AdminChatSessionDetail,
  AdminChatSessionDetailSchema,
  type AdminChatSessionList,
  type AdminChatSessionListQuery,
  AdminChatSessionListSchema,
  type AdminChatSessionTrace,
  AdminChatSessionTraceSchema,
  type AdminFamilySite,
  type AdminFamilySiteList,
  AdminFamilySiteListSchema,
  AdminFamilySiteSchema,
  type AdminFileUploadActiveSummary,
  AdminFileUploadActiveSummarySchema,
  type AdminFileUploadCancelRequest,
  type AdminFileUploadDeleteOrphansRequest,
  type AdminFileUploadDeleteOrphansResponse,
  AdminFileUploadDeleteOrphansResponseSchema,
  type AdminFileUploadDeleteRequest,
  type AdminFileUploadDeleteResponse,
  AdminFileUploadDeleteResponseSchema,
  type AdminFileUploadList,
  type AdminFileUploadListItem,
  AdminFileUploadListItemSchema,
  type AdminFileUploadListQuery,
  AdminFileUploadListSchema,
  type AdminInsightAgentLogResponse,
  AdminInsightAgentLogResponseSchema,
  type AdminSmtpConfig,
  AdminSmtpConfigSchema,
  type AdminStorageConfig,
  AdminStorageConfigSchema,
  type AdminUsageStatsOverview,
  AdminUsageStatsOverviewSchema,
  type AdminUsageStatsQuery,
  type AdminUsageStatsTopListQuery,
  type AdminUsageStatsTopSkillsList,
  AdminUsageStatsTopSkillsListSchema,
  type AdminUsageStatsTopToolsList,
  AdminUsageStatsTopToolsListSchema,
  type AdminUsageStatsTopUsersList,
  AdminUsageStatsTopUsersListSchema,
  type AdminUser,
  type AdminUserList,
  type AdminUserListQuery,
  AdminUserListSchema,
  AdminUserSchema,
  type AgentSummary,
  AgentSummarySchema,
  ApiErrorSchema,
  type ApiKeyList,
  ApiKeyListSchema,
  type ApiKeyScope,
  type ApiKeySettings,
  ApiKeySettingsSchema,
  type ApiKeyUsageList,
  ApiKeyUsageListSchema,
  type ApiKeyUsageQuery,
  type ApiKeyWithSecret,
  ApiKeyWithSecretSchema,
  type ArtifactDetail,
  ArtifactDetailSchema,
  type ArtifactList,
  ArtifactListSchema,
  type ArtifactRpcMethod,
  type ArtifactRpcResponse,
  ArtifactRpcResponseSchema,
  type ArtifactVersion,
  ArtifactVersionSchema,
  type AuditLogList,
  AuditLogListSchema,
  type AuditLogQuery,
  type AuditSkillCommitRequest,
  type AuthConfigResponse,
  AuthConfigResponseSchema,
  type AuthConfigUpdateRequest,
  type AuthProvidersResponse,
  AuthProvidersResponseSchema,
  type BannedKeyword,
  type BannedKeywordList,
  BannedKeywordListSchema,
  BannedKeywordSchema,
  type BrokenBacklinkCleanup,
  BrokenBacklinkCleanupSchema,
  type BrokenBacklinkScan,
  BrokenBacklinkScanSchema,
  type CancelServerJobResponse,
  CancelServerJobResponseSchema,
  type ChangePasswordRequest,
  type ChatModelList,
  ChatModelListSchema,
  type ChatProject,
  type ChatProjectList,
  ChatProjectListSchema,
  ChatProjectSchema,
  type ChatSession,
  type ChatSessionDetail,
  ChatSessionDetailSchema,
  type ChatSessionList,
  ChatSessionListSchema,
  ChatSessionSchema,
  type CreateAdminAgentRequest,
  type CreateAgentApiKeyRequest,
  type CreateAgentApiKeyResponse,
  CreateAgentApiKeyResponseSchema,
  type CreateApiKeyRequest,
  type CreateBannedKeywordRequest,
  type CreateChatProjectRequest,
  type CreateChatSessionRequest,
  type CreateChatSessionResponse,
  CreateChatSessionResponseSchema,
  type CreateDataSourceRequest,
  type CreateFamilySiteRequest,
  type CreateHttpEndpointRequest,
  type CreateLlmBondingRequest,
  type CreateLlmEndpointRequest,
  type CreateScopeRuleRequest,
  type CreateSkillRequest,
  type CreateSlidePageRequest,
  type CreateSlideRequest,
  type CreateUserAttributeRequest,
  type CreateUserGroupRequest,
  type CreateUserRequest,
  type CreateWikiCategoryRequest,
  type DataSource,
  type DataSourceJobsResponse,
  DataSourceJobsResponseSchema,
  type DataSourceList,
  DataSourceListSchema,
  DataSourceSchema,
  type DataSourceTableDetail,
  DataSourceTableDetailSchema,
  type DataSourceTableList,
  DataSourceTableListSchema,
  type DataSourceTablePreviewResponse,
  DataSourceTablePreviewResponseSchema,
  type DeadSourceLinkCleanup,
  DeadSourceLinkCleanupSchema,
  type DeadSourceLinkScan,
  DeadSourceLinkScanSchema,
  type DeleteServerJobResponse,
  DeleteServerJobResponseSchema,
  type DirectorySearchResponse,
  DirectorySearchResponseSchema,
  type DocumentProcessingConfig,
  DocumentProcessingConfigSchema,
  type DocumentProcessingConfigUpdate,
  type ExcelCheckPkDuplicatesRequest,
  type ExcelCheckPkDuplicatesResponse,
  ExcelCheckPkDuplicatesResponseSchema,
  type FavoriteSlideRequest,
  type FileUpload,
  type FileUploadList,
  FileUploadListSchema,
  FileUploadSchema,
  type GenerateDescriptionsResponse,
  GenerateDescriptionsResponseSchema,
  type HttpEndpoint,
  type HttpEndpointList,
  HttpEndpointListSchema,
  HttpEndpointSchema,
  type IncorporateLessonsCommitRequest,
  type IncorporateLessonsProposal,
  IncorporateLessonsProposalSchema,
  type IncorporateLessonsRequest,
  type IsignConfigTestRequest,
  type IsignConfigTestResponse,
  IsignConfigTestResponseSchema,
  type IsignConfigUpdateRequest,
  type LdapConfigTestRequest,
  type LdapConfigTestResponse,
  LdapConfigTestResponseSchema,
  type LdapConfigUpdateRequest,
  type LicenseChallengeRequest,
  type LicenseChallengeResponse,
  LicenseChallengeResponseSchema,
  type LicenseInstallRequest,
  type LicenseInstallResponse,
  LicenseInstallResponseSchema,
  type LicenseSlotActionResponse,
  LicenseSlotActionResponseSchema,
  type LicenseStatus,
  LicenseStatusSchema,
  type ListAdminAgentsResponse,
  ListAdminAgentsResponseSchema,
  type ListAgentApiKeysResponse,
  ListAgentApiKeysResponseSchema,
  type LlmBonding,
  type LlmBondingDetail,
  LlmBondingDetailSchema,
  type LlmBondingList,
  LlmBondingListSchema,
  type LlmBondingProbeDraftRequest,
  type LlmBondingProbeResponse,
  LlmBondingProbeResponseSchema,
  LlmBondingSchema,
  type LlmConcurrencySlotsResponse,
  LlmConcurrencySlotsResponseSchema,
  type LlmConcurrencyStatus,
  LlmConcurrencyStatusSchema,
  type LlmEndpoint,
  type LlmEndpointList,
  LlmEndpointListSchema,
  LlmEndpointSchema,
  type LoginRequest,
  type LogoutResponse,
  LogoutResponseSchema,
  type MicrosoftEntraTestRequest,
  type MicrosoftEntraTestResponse,
  MicrosoftEntraTestResponseSchema,
  type MicrosoftEntraUpdateRequest,
  type MoveChatSessionRequest,
  type OnboardingAdminRequest,
  type OnboardingDbRequest,
  type OnboardingDbResponse,
  OnboardingDbResponseSchema,
  type OnboardingLlmRequest,
  type OnboardingStatus,
  OnboardingStatusSchema,
  type OnboardingStorageRequest,
  type ProbeAllResponse,
  ProbeAllResponseSchema,
  type ProbeDraftRequest,
  type ProbeResponse,
  ProbeResponseSchema,
  type PublicAppSettings,
  PublicAppSettingsSchema,
  type PublicBranding,
  PublicBrandingSchema,
  type PublicFamilySiteList,
  PublicFamilySiteListSchema,
  type PublicUser,
  PublicUserSchema,
  type RemoveBondingMemberRequest,
  type RenameChatProjectRequest,
  type RenameChatSessionRequest,
  type RenameSlideRequest,
  type RenameUserGroupRequest,
  type ReorderFamilySitesRequest,
  type ReorderSlidePagesRequest,
  type ResetPasswordResponse,
  ResetPasswordResponseSchema,
  type RunUserSyncResponse,
  RunUserSyncResponseSchema,
  type SavedQueryDeleteOrphansRequest,
  type SavedQueryDeleteOrphansResponse,
  SavedQueryDeleteOrphansResponseSchema,
  type SavedQueryDeleteRequest,
  type SavedQueryDeleteResponse,
  SavedQueryDeleteResponseSchema,
  type SavedQueryList,
  type SavedQueryListItem,
  SavedQueryListItemSchema,
  type SavedQueryListQuery,
  SavedQueryListSchema,
  type SavedQueryPreviewResponse,
  SavedQueryPreviewResponseSchema,
  type ScopeRule,
  type ScopeRuleList,
  ScopeRuleListSchema,
  ScopeRuleSchema,
  type SearchWikiResponse,
  SearchWikiResponseSchema,
  type ServerJobList,
  ServerJobListSchema,
  type SetChatSessionModelRequest,
  type SetSlideDesignRequest,
  type Skill,
  type SkillAuditRun,
  type SkillAuditRunLatest,
  SkillAuditRunLatestSchema,
  SkillAuditRunSchema,
  type SkillLesson,
  type SkillLessonList,
  type SkillLessonListQuery,
  SkillLessonListSchema,
  type SkillLessonPendingCount,
  SkillLessonPendingCountSchema,
  SkillLessonSchema,
  type SkillList,
  SkillListSchema,
  type SkillPromptVersion,
  type SkillPromptVersionList,
  SkillPromptVersionListSchema,
  SkillPromptVersionSchema,
  SkillSchema,
  type Slide,
  type SlideAsset,
  type SlideAssetListResponse,
  SlideAssetListResponseSchema,
  SlideAssetSchema,
  type SlideListResponse,
  SlideListResponseSchema,
  type SlidePage,
  SlidePageSchema,
  type SlidePageVersionListResponse,
  SlidePageVersionListResponseSchema,
  SlideSchema,
  type SlidesConfig,
  SlidesConfigSchema,
  type StartSkillAuditResponse,
  StartSkillAuditResponseSchema,
  type SttCapabilities,
  SttCapabilitiesSchema,
  type SttTranscribeResponse,
  SttTranscribeResponseSchema,
  type SyncCancelResponse,
  SyncCancelResponseSchema,
  type SyncRequest,
  type SyncResponse,
  SyncResponseSchema,
  type SystemHealth,
  SystemHealthSchema,
  type SystemInfo,
  SystemInfoSchema,
  type SystemPromptDetail,
  SystemPromptDetailSchema,
  type SystemPromptSummaryList,
  SystemPromptSummaryListSchema,
  type SystemPromptVersionList,
  SystemPromptVersionListSchema,
  type SystemSettings,
  SystemSettingsSchema,
  type TestConnectionRequest,
  type TestConnectionResponse,
  TestConnectionResponseSchema,
  type TestHttpEndpointResponse,
  TestHttpEndpointResponseSchema,
  type TestSmtpRequest,
  type TestStorageRequest,
  type TestStorageResponse,
  TestStorageResponseSchema,
  type ToggleChatSessionFavoriteRequest,
  type UpdateAdminAgentRequest,
  type UpdateApiKeySettingsRequest,
  type UpdateBannedKeywordRequest,
  type UpdateBrandingRequest,
  type UpdateColumnDescriptionRequest,
  type UpdateDataSourceRequest,
  type UpdateFamilySiteRequest,
  type UpdateHttpEndpointRequest,
  type UpdateLlmBondingRequest,
  type UpdateLlmEndpointRequest,
  type UpdateScopeRuleRequest,
  type UpdateSkillLessonRequest,
  type UpdateSkillRequest,
  type UpdateSlidePageRequest,
  type UpdateSlidesConfigRequest,
  type UpdateSmtpConfigRequest,
  type UpdateStorageRequest,
  type UpdateStorageResponse,
  UpdateStorageResponseSchema,
  type UpdateSystemSettingsRequest,
  type UpdateTableDescriptionRequest,
  type UpdateTableUserScopeRequest,
  type UpdateUserAttributeRequest,
  type UpdateUserRequest,
  type UpdateWikiCategoryRequest,
  type UpdateWikiConfigRequest,
  type UpdateWikiPageRequest,
  type UserAttributeDefinition,
  type UserAttributeDefinitionList,
  UserAttributeDefinitionListSchema,
  UserAttributeDefinitionSchema,
  type UserGroupDetail,
  UserGroupDetailSchema,
  type UserGroupSummary,
  type UserGroupSummaryList,
  UserGroupSummaryListSchema,
  UserGroupSummarySchema,
  type UserSyncConfig,
  type UserSyncConfigResponse,
  UserSyncConfigResponseSchema,
  type UserSyncPreviewResponse,
  UserSyncPreviewResponseSchema,
  type UserSyncRunList,
  UserSyncRunListSchema,
  type WikiCategory,
  type WikiCategoryList,
  WikiCategoryListSchema,
  WikiCategorySchema,
  type WikiConfig,
  WikiConfigSchema,
  type WikiDocument,
  type WikiDocumentDetail,
  WikiDocumentDetailSchema,
  type WikiDocumentList,
  WikiDocumentListSchema,
  WikiDocumentSchema,
  type WikiEmbeddingsByEndpoint,
  WikiEmbeddingsByEndpointSchema,
  type WikiExternalSyncLogList,
  WikiExternalSyncLogListSchema,
  type WikiGraphResponse,
  WikiGraphResponseSchema,
  type WikiGraphStats,
  WikiGraphStatsSchema,
  type WikiHubCurateQueuedResponse,
  WikiHubCurateQueuedResponseSchema,
  type WikiHubsRegenerateResponse,
  WikiHubsRegenerateResponseSchema,
  type WikiIndex,
  WikiIndexSchema,
  type WikiLogResponse,
  WikiLogResponseSchema,
  type WikiPage,
  type WikiPageList,
  WikiPageListSchema,
  WikiPageSchema,
  type WikiReembedAllResponse,
  WikiReembedAllResponseSchema,
  type WikiReingestStartResponse,
  WikiReingestStartResponseSchema,
  type WikiReingestStatus,
  WikiReingestStatusSchema,
  type WikiRuntimeReport,
  WikiRuntimeReportSchema,
  type WikiSimilarPagesResponse,
  WikiSimilarPagesResponseSchema,
} from '@innermate/shared';
import {
  type ArtifactDashboardSpecRequest,
  type DashboardDetail,
  DashboardDetailSchema,
  type DashboardGroupOptionList,
  DashboardGroupOptionListSchema,
  type DashboardProfileResponse,
  DashboardProfileResponseSchema,
  type DashboardSharesResponse,
  DashboardSharesResponseSchema,
  type DashboardSummaryList,
  DashboardSummaryListSchema,
  type EditDashboardSpecRequest,
  type RenameDashboardRequest,
  type ReorderDashboardsRequest,
  type SaveDashboardRequest,
  type ShareDashboardRequest,
  type SharedDashboardSummaryList,
  SharedDashboardSummaryListSchema,
  type UpdateDashboardSettingsRequest,
  type WidgetRenderRequest,
  type WidgetRenderResponse,
  WidgetRenderResponseSchema,
} from '@innermate/shared';
import {
  type CreateTableauDataSourceRequest,
  type DuckdbTableauSourceResponse,
  DuckdbTableauSourceResponseSchema,
  type IntegrateTableauResourceRequest,
  type IntegrateTableauResourceResponse,
  IntegrateTableauResourceResponseSchema,
  type SetTableauScheduleRequest,
  type TableauResourceListResponse,
  TableauResourceListResponseSchema,
  type TestTableauConnectionRequest,
  type UpdateTableauDataSourceRequest,
  type UpdateTableauResourceDescriptionRequest,
} from '@innermate/shared';
import {
  type CreateResourceHostRequest,
  type ResourceHost,
  type ResourceHostList,
  ResourceHostListSchema,
  ResourceHostSchema,
  type ResourceMetricsHistoryResponse,
  ResourceMetricsHistoryResponseSchema,
  type ResourceMetricsLatestResponse,
  ResourceMetricsLatestResponseSchema,
  type ResourceMetricsRangeDistributionMetric,
  type ResourceMetricsRangeDistributionResponse,
  ResourceMetricsRangeDistributionResponseSchema,
  type ResourceMetricsRangeHeatmapResponse,
  ResourceMetricsRangeHeatmapResponseSchema,
  type ResourceMetricsRangeStatisticsResponse,
  ResourceMetricsRangeStatisticsResponseSchema,
  type ResourceMetricsRangeTimeseriesResponse,
  ResourceMetricsRangeTimeseriesResponseSchema,
  type ResourceMetricsRangeWindow,
  type TestResourceHostConnectionRequest,
  type TestResourceHostConnectionResponse,
  TestResourceHostConnectionResponseSchema,
  type UpdateResourceHostRequest,
} from '@innermate/shared';
import {
  type AddRoleExclusionRequest,
  type CreateRbacRoleRequest,
  type EffectiveSkillEntry,
  EffectiveSkillEntrySchema,
  type RbacMatchMode,
  RbacMatchModeSchema,
  type RbacRole,
  type RbacRoleListResponse,
  RbacRoleListResponseSchema,
  RbacRoleSchema,
  type RoleAttributeGrantsResponse,
  RoleAttributeGrantsResponseSchema,
  type SetRoleAttributeGrantsRequest,
  type SetRoleMembersRequest,
  type SetRoleSkillsRequest,
  type SetUserRolesRequest,
  type UpdateRbacRoleRequest,
  type UpdateSessionSkillsRequest,
} from '@innermate/shared';
import {
  type BulkUpdateActiveTagsRequest,
  type BulkUpdateActiveTagsResponse,
  BulkUpdateActiveTagsResponseSchema,
  type CreateResponsePromptRequest,
  type CreateResponsePromptTestCaseRequest,
  type CreateResponsePromptVariantRequest,
  type DuplicateResponsePromptRequest,
  type MoveResponsePromptRequest,
  type RenameResponsePromptRequest,
  type RenameResponsePromptVariantRequest,
  type ResponsePromptDetail,
  ResponsePromptDetailSchema,
  type ResponsePromptExport,
  ResponsePromptExportSchema,
  type ResponsePromptImportResponse,
  ResponsePromptImportResponseSchema,
  type ResponsePromptTestCase,
  type ResponsePromptTestCaseList,
  ResponsePromptTestCaseListSchema,
  ResponsePromptTestCaseSchema,
  type ResponsePromptTree,
  ResponsePromptTreeSchema,
  type ResponsePromptVariant,
  ResponsePromptVariantSchema,
  type RunResponsePromptTestRequest,
  type RunResponsePromptTestResponse,
  RunResponsePromptTestResponseSchema,
  type SaveResponsePromptVersionRequest,
  type UpdateResponsePromptVersionTagsRequest,
} from '@innermate/shared';
import { z } from 'zod';

class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: string,
    message: string,
    public readonly details?: unknown,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

async function request<T>(path: string, init: RequestInit, schema: z.ZodType<T>): Promise<T> {
  const hasBody = init.body !== undefined && init.body !== null;
  const res = await fetch(path, {
    credentials: 'include',
    ...init,
    headers: {
      ...(hasBody ? { 'content-type': 'application/json' } : {}),
      ...(init.headers ?? {}),
    },
  });
  const text = await res.text();
  const json = text ? JSON.parse(text) : null;
  if (!res.ok) {
    const parsed = ApiErrorSchema.safeParse(json);
    if (parsed.success) {
      throw new ApiError(
        res.status,
        parsed.data.error.code,
        parsed.data.error.message,
        parsed.data.error.details,
      );
    }
    throw new ApiError(res.status, 'INTERNAL', `요청 실패 (${res.status})`);
  }
  // schema.parse 실패 (대표적으로 client/server 스키마 불일치 — 옛 client bundle 캐시) 에 대비해
  // 콘솔에 어느 필드가 미스매치인지 자세히 출력. 개발자가 즉시 진단 가능.
  const parsed = schema.safeParse(json);
  if (!parsed.success) {
    console.error('[api] 응답 스키마 검증 실패', {
      path,
      issues: parsed.error.issues,
    });
    throw parsed.error;
  }
  return parsed.data;
}

const OkSchema = z.object({ ok: z.boolean() });
const UserResponseSchema = z.object({ user: PublicUserSchema });

export const api = {
  onboardingStatus: (): Promise<OnboardingStatus> =>
    request('/api/onboarding/status', { method: 'GET' }, OnboardingStatusSchema),

  // --- License ---
  licenseStatus: (): Promise<LicenseStatus> =>
    request('/api/license/status', { method: 'GET' }, LicenseStatusSchema),
  licenseChallenge: (body: LicenseChallengeRequest): Promise<LicenseChallengeResponse> =>
    request(
      '/api/license/challenge',
      { method: 'POST', body: JSON.stringify(body) },
      LicenseChallengeResponseSchema,
    ),
  licenseInstall: (body: LicenseInstallRequest): Promise<LicenseInstallResponse> =>
    request(
      '/api/license/install',
      { method: 'POST', body: JSON.stringify(body) },
      LicenseInstallResponseSchema,
    ),
  licenseSlotActivate: (slotId: string): Promise<LicenseSlotActionResponse> =>
    request(
      `/api/license/slots/${slotId}/activate`,
      { method: 'POST' },
      LicenseSlotActionResponseSchema,
    ),
  licenseSlotRetire: (
    slotId: string,
    reason: 'manual' | 'invalid' | 'replaced' = 'manual',
  ): Promise<LicenseSlotActionResponse> =>
    request(
      `/api/license/slots/${slotId}/retire`,
      { method: 'POST', body: JSON.stringify({ reason }) },
      LicenseSlotActionResponseSchema,
    ),

  authProviders: (): Promise<AuthProvidersResponse> =>
    request('/api/auth/providers', { method: 'GET' }, AuthProvidersResponseSchema),

  login: (body: LoginRequest): Promise<{ user: PublicUser }> =>
    request('/api/auth/login', { method: 'POST', body: JSON.stringify(body) }, UserResponseSchema),

  loginLdap: (body: LoginRequest): Promise<{ user: PublicUser }> =>
    request(
      '/api/auth/ldap/login',
      { method: 'POST', body: JSON.stringify(body) },
      UserResponseSchema,
    ),

  logout: (): Promise<LogoutResponse> =>
    request('/api/auth/logout', { method: 'POST' }, LogoutResponseSchema),

  me: (): Promise<{ user: PublicUser }> =>
    request('/api/auth/me', { method: 'GET' }, UserResponseSchema),

  changePassword: (body: ChangePasswordRequest): Promise<{ ok: boolean }> =>
    request('/api/auth/password/update', { method: 'POST', body: JSON.stringify(body) }, OkSchema),

  onboardingDb: (body: OnboardingDbRequest): Promise<OnboardingDbResponse> =>
    request(
      '/api/onboarding/db',
      { method: 'POST', body: JSON.stringify(body) },
      OnboardingDbResponseSchema,
    ),

  onboardingStorage: (body: OnboardingStorageRequest) =>
    request(
      '/api/onboarding/storage',
      { method: 'POST', body: JSON.stringify(body) },
      z.object({ ok: z.boolean(), skipped: z.boolean() }),
    ),

  onboardingStorageTest: (body: OnboardingStorageRequest): Promise<TestStorageResponse> =>
    request(
      '/api/onboarding/storage/test',
      { method: 'POST', body: JSON.stringify(body) },
      TestStorageResponseSchema,
    ),

  onboardingAdmin: (body: OnboardingAdminRequest) =>
    request('/api/onboarding/admin', { method: 'POST', body: JSON.stringify(body) }, OkSchema),

  onboardingLlm: (body: OnboardingLlmRequest) =>
    request('/api/onboarding/llm', { method: 'POST', body: JSON.stringify(body) }, OkSchema),

  onboardingFinish: () => request('/api/onboarding/finish', { method: 'POST' }, OkSchema),

  appSettings: (): Promise<PublicAppSettings> =>
    request('/api/app/settings', { method: 'GET' }, PublicAppSettingsSchema),

  branding: (): Promise<PublicBranding> =>
    request('/api/branding', { method: 'GET' }, PublicBrandingSchema),

  adminBranding: (): Promise<AdminBranding> =>
    request('/api/admin/branding', { method: 'GET' }, AdminBrandingSchema),

  adminUpdateBranding: (body: UpdateBrandingRequest): Promise<AdminBranding> =>
    request(
      '/api/admin/branding/update',
      { method: 'POST', body: JSON.stringify(body) },
      AdminBrandingSchema,
    ),

  adminUploadBrandingLogo: async (file: File): Promise<AdminBranding> => {
    const fd = new FormData();
    fd.append('file', file, file.name);
    const res = await fetch('/api/admin/branding/upload-logo', {
      method: 'POST',
      credentials: 'include',
      body: fd,
    });
    const text = await res.text();
    const json = text ? JSON.parse(text) : null;
    if (!res.ok) {
      const parsed = ApiErrorSchema.safeParse(json);
      if (parsed.success) {
        throw new ApiError(
          res.status,
          parsed.data.error.code,
          parsed.data.error.message,
          parsed.data.error.details,
        );
      }
      throw new ApiError(res.status, 'INTERNAL', `로고 업로드 실패 (${res.status})`);
    }
    return AdminBrandingSchema.parse(json);
  },

  adminDeleteBrandingLogo: (): Promise<AdminBranding> =>
    request('/api/admin/branding/delete-logo', { method: 'POST' }, AdminBrandingSchema),

  adminUploadBrandingFavicon: async (file: File): Promise<AdminBranding> => {
    const fd = new FormData();
    fd.append('file', file, file.name);
    const res = await fetch('/api/admin/branding/upload-favicon', {
      method: 'POST',
      credentials: 'include',
      body: fd,
    });
    const text = await res.text();
    const json = text ? JSON.parse(text) : null;
    if (!res.ok) {
      const parsed = ApiErrorSchema.safeParse(json);
      if (parsed.success) {
        throw new ApiError(
          res.status,
          parsed.data.error.code,
          parsed.data.error.message,
          parsed.data.error.details,
        );
      }
      throw new ApiError(res.status, 'INTERNAL', `파비콘 업로드 실패 (${res.status})`);
    }
    return AdminBrandingSchema.parse(json);
  },

  adminDeleteBrandingFavicon: (): Promise<AdminBranding> =>
    request('/api/admin/branding/delete-favicon', { method: 'POST' }, AdminBrandingSchema),

  adminSystemInfo: (): Promise<SystemInfo> =>
    request('/api/admin/system-info', { method: 'GET' }, SystemInfoSchema),

  adminSystemHealth: (): Promise<SystemHealth> =>
    request('/api/admin/system-health', { method: 'GET' }, SystemHealthSchema),

  adminSettings: (): Promise<SystemSettings> =>
    request('/api/admin/settings', { method: 'GET' }, SystemSettingsSchema),

  adminUpdateSettings: (body: UpdateSystemSettingsRequest): Promise<SystemSettings> =>
    request(
      '/api/admin/settings/update',
      { method: 'POST', body: JSON.stringify(body) },
      SystemSettingsSchema,
    ),

  adminAuthConfig: (): Promise<AuthConfigResponse> =>
    request('/api/admin/auth/config', { method: 'GET' }, AuthConfigResponseSchema),

  adminAuthConfigUpdate: (body: AuthConfigUpdateRequest): Promise<{ ok: boolean }> =>
    request(
      '/api/admin/auth/config/update',
      { method: 'POST', body: JSON.stringify(body) },
      OkSchema,
    ),

  adminAuthMicrosoftUpdate: (body: MicrosoftEntraUpdateRequest): Promise<{ ok: boolean }> =>
    request(
      '/api/admin/auth/microsoft/update',
      { method: 'POST', body: JSON.stringify(body) },
      OkSchema,
    ),

  adminAuthMicrosoftTest: (body: MicrosoftEntraTestRequest): Promise<MicrosoftEntraTestResponse> =>
    request(
      '/api/admin/auth/microsoft/test',
      { method: 'POST', body: JSON.stringify(body) },
      MicrosoftEntraTestResponseSchema,
    ),

  adminAuthLdapUpdate: (body: LdapConfigUpdateRequest): Promise<{ ok: boolean }> =>
    request(
      '/api/admin/auth/ldap/update',
      { method: 'POST', body: JSON.stringify(body) },
      OkSchema,
    ),

  adminAuthLdapTest: (body: LdapConfigTestRequest): Promise<LdapConfigTestResponse> =>
    request(
      '/api/admin/auth/ldap/test',
      { method: 'POST', body: JSON.stringify(body) },
      LdapConfigTestResponseSchema,
    ),

  adminAuthIsignUpdate: (body: IsignConfigUpdateRequest): Promise<{ ok: boolean }> =>
    request(
      '/api/admin/auth/isign/update',
      { method: 'POST', body: JSON.stringify(body) },
      OkSchema,
    ),

  adminAuthIsignTest: (body: IsignConfigTestRequest): Promise<IsignConfigTestResponse> =>
    request(
      '/api/admin/auth/isign/test',
      { method: 'POST', body: JSON.stringify(body) },
      IsignConfigTestResponseSchema,
    ),

  adminAuthForceLogout: (): Promise<{ ok: boolean; sessionEpoch: number }> =>
    request(
      '/api/admin/auth/force-logout',
      { method: 'POST' },
      z.object({ ok: z.boolean(), sessionEpoch: z.number() }),
    ),

  adminSmtpGet: (): Promise<AdminSmtpConfig> =>
    request('/api/admin/smtp/config', { method: 'GET' }, AdminSmtpConfigSchema),

  adminSmtpUpdate: (body: UpdateSmtpConfigRequest): Promise<{ ok: boolean }> =>
    request(
      '/api/admin/smtp/update',
      { method: 'POST', body: JSON.stringify(body) },
      z.object({ ok: z.boolean() }),
    ),

  adminSmtpTest: (body: TestSmtpRequest): Promise<{ ok: boolean; message: string }> =>
    request(
      '/api/admin/smtp/test',
      { method: 'POST', body: JSON.stringify(body) },
      z.object({ ok: z.boolean(), message: z.string() }),
    ),

  adminStorageGet: (): Promise<AdminStorageConfig> =>
    request('/api/admin/storage', { method: 'GET' }, AdminStorageConfigSchema),

  adminStorageUpdate: (body: UpdateStorageRequest): Promise<UpdateStorageResponse> =>
    request(
      '/api/admin/storage/update',
      { method: 'POST', body: JSON.stringify(body) },
      UpdateStorageResponseSchema,
    ),

  adminStorageTest: (body: TestStorageRequest): Promise<TestStorageResponse> =>
    request(
      '/api/admin/storage/test',
      { method: 'POST', body: JSON.stringify(body) },
      TestStorageResponseSchema,
    ),

  adminUsersList: (query?: AdminUserListQuery): Promise<AdminUserList> => {
    const params = new URLSearchParams();
    if (query?.search) params.set('search', query.search);
    if (query?.limit != null) params.set('limit', String(query.limit));
    if (query?.offset != null) params.set('offset', String(query.offset));
    const qs = params.toString();
    return request(
      qs ? `/api/admin/users?${qs}` : '/api/admin/users',
      { method: 'GET' },
      AdminUserListSchema,
    );
  },

  /** 사용자 단건 조회. 상세 페이지에서 list 캐시 대신 직접 호출. */
  adminUserGet: (id: string): Promise<AdminUser> =>
    request(`/api/admin/users/${encodeURIComponent(id)}`, { method: 'GET' }, AdminUserSchema),

  adminCreateUser: (body: CreateUserRequest): Promise<AdminUser> =>
    request('/api/admin/users', { method: 'POST', body: JSON.stringify(body) }, AdminUserSchema),

  adminUpdateUser: (id: string, body: UpdateUserRequest): Promise<AdminUser> =>
    request(
      `/api/admin/users/${encodeURIComponent(id)}`,
      { method: 'PATCH', body: JSON.stringify(body) },
      AdminUserSchema,
    ),

  adminResetPassword: (id: string): Promise<ResetPasswordResponse> =>
    request(
      `/api/admin/users/${encodeURIComponent(id)}/reset-password`,
      { method: 'POST' },
      ResetPasswordResponseSchema,
    ),

  adminDeleteUser: (id: string): Promise<null> =>
    request(`/api/admin/users/${encodeURIComponent(id)}`, { method: 'DELETE' }, z.null()),

  adminAuditLogs: (query: AuditLogQuery): Promise<AuditLogList> => {
    const params = new URLSearchParams();
    if (query.action) params.set('action', query.action);
    if (query.actorEmail) params.set('actorEmail', query.actorEmail);
    if (query.from) params.set('from', query.from);
    if (query.to) params.set('to', query.to);
    if (query.status) params.set('status', query.status);
    if (query.cursor) params.set('cursor', query.cursor);
    if (query.limit) params.set('limit', String(query.limit));
    const qs = params.toString();
    return request(
      `/api/admin/audit-logs${qs ? `?${qs}` : ''}`,
      { method: 'GET' },
      AuditLogListSchema,
    );
  },

  adminSavedQueries: (query: SavedQueryListQuery): Promise<SavedQueryList> => {
    const params = new URLSearchParams();
    if (query.ownerEmail) params.set('ownerEmail', query.ownerEmail);
    if (query.kind) params.set('kind', query.kind);
    if (query.from) params.set('from', query.from);
    if (query.to) params.set('to', query.to);
    if (query.cursor) params.set('cursor', query.cursor);
    if (query.limit) params.set('limit', String(query.limit));
    const qs = params.toString();
    return request(
      `/api/admin/saved-queries${qs ? `?${qs}` : ''}`,
      { method: 'GET' },
      SavedQueryListSchema,
    );
  },

  adminGetSavedQuery: (id: string): Promise<SavedQueryListItem> =>
    request(
      `/api/admin/saved-queries/${encodeURIComponent(id)}`,
      { method: 'GET' },
      SavedQueryListItemSchema,
    ),

  adminDeleteSavedQuery: (
    id: string,
    body: SavedQueryDeleteRequest = {},
  ): Promise<SavedQueryDeleteResponse> =>
    request(
      `/api/admin/saved-queries/${encodeURIComponent(id)}/delete`,
      { method: 'POST', body: JSON.stringify(body) },
      SavedQueryDeleteResponseSchema,
    ),

  adminDeleteOrphanSavedQueries: (
    body: SavedQueryDeleteOrphansRequest,
  ): Promise<SavedQueryDeleteOrphansResponse> =>
    request(
      '/api/admin/saved-queries/delete-orphans',
      { method: 'POST', body: JSON.stringify(body) },
      SavedQueryDeleteOrphansResponseSchema,
    ),

  adminGetChatSessionDetail: (id: string): Promise<AdminChatSessionDetail> =>
    request(
      `/api/admin/chat-sessions/${encodeURIComponent(id)}`,
      { method: 'GET' },
      AdminChatSessionDetailSchema,
    ),

  adminListChatSessions: (query: AdminChatSessionListQuery): Promise<AdminChatSessionList> => {
    const params = new URLSearchParams();
    for (const id of query.userIds ?? []) params.append('userIds', id);
    for (const id of query.skillIds ?? []) params.append('skillIds', id);
    for (const id of query.llmEndpointIds ?? []) params.append('llmEndpointIds', id);
    if (query.from) params.set('from', query.from);
    if (query.to) params.set('to', query.to);
    if (query.hasError) params.set('hasError', query.hasError);
    if (query.hasHitl) params.set('hasHitl', query.hasHitl);
    if (query.agentOnly) params.set('agentOnly', query.agentOnly);
    if (query.desktopOnly) params.set('desktopOnly', query.desktopOnly);
    if (query.hasBannedWord) params.set('hasBannedWord', query.hasBannedWord);
    if (query.search) params.set('search', query.search);
    const qs = params.toString();
    return request(
      `/api/admin/chat-sessions${qs ? `?${qs}` : ''}`,
      { method: 'GET' },
      AdminChatSessionListSchema,
    );
  },

  adminGetChatSessionTrace: (id: string): Promise<AdminChatSessionTrace> =>
    request(
      `/api/admin/chat-sessions/${encodeURIComponent(id)}/trace`,
      { method: 'GET' },
      AdminChatSessionTraceSchema,
    ),

  adminGetInsightAgentLog: (
    sessionId: string,
    rowId: number,
  ): Promise<AdminInsightAgentLogResponse> =>
    request(
      `/api/admin/insight-agent-logs/${encodeURIComponent(sessionId)}/${rowId}`,
      { method: 'GET' },
      AdminInsightAgentLogResponseSchema,
    ),

  adminGetUsageStatsOverview: (query: AdminUsageStatsQuery): Promise<AdminUsageStatsOverview> => {
    const params = new URLSearchParams();
    params.set('from', query.from);
    params.set('to', query.to);
    for (const id of query.userIds ?? []) params.append('userIds', id);
    for (const id of query.skillIds ?? []) params.append('skillIds', id);
    for (const id of query.llmEndpointIds ?? []) params.append('llmEndpointIds', id);
    return request(
      `/api/admin/usage-stats/overview?${params.toString()}`,
      { method: 'GET' },
      AdminUsageStatsOverviewSchema,
    );
  },

  adminGetUsageStatsTopUsers: (
    query: AdminUsageStatsTopListQuery,
  ): Promise<AdminUsageStatsTopUsersList> => {
    const params = new URLSearchParams();
    params.set('from', query.from);
    params.set('to', query.to);
    for (const id of query.userIds ?? []) params.append('userIds', id);
    for (const id of query.skillIds ?? []) params.append('skillIds', id);
    for (const id of query.llmEndpointIds ?? []) params.append('llmEndpointIds', id);
    params.set('offset', String(query.offset));
    params.set('limit', String(query.limit));
    return request(
      `/api/admin/usage-stats/top-users?${params.toString()}`,
      { method: 'GET' },
      AdminUsageStatsTopUsersListSchema,
    );
  },

  adminGetUsageStatsTopSkills: (
    query: AdminUsageStatsTopListQuery,
  ): Promise<AdminUsageStatsTopSkillsList> => {
    const params = new URLSearchParams();
    params.set('from', query.from);
    params.set('to', query.to);
    for (const id of query.userIds ?? []) params.append('userIds', id);
    for (const id of query.skillIds ?? []) params.append('skillIds', id);
    for (const id of query.llmEndpointIds ?? []) params.append('llmEndpointIds', id);
    params.set('offset', String(query.offset));
    params.set('limit', String(query.limit));
    return request(
      `/api/admin/usage-stats/top-skills?${params.toString()}`,
      { method: 'GET' },
      AdminUsageStatsTopSkillsListSchema,
    );
  },

  adminGetUsageStatsTopTools: (
    query: AdminUsageStatsTopListQuery,
  ): Promise<AdminUsageStatsTopToolsList> => {
    const params = new URLSearchParams();
    params.set('from', query.from);
    params.set('to', query.to);
    for (const id of query.userIds ?? []) params.append('userIds', id);
    for (const id of query.skillIds ?? []) params.append('skillIds', id);
    for (const id of query.llmEndpointIds ?? []) params.append('llmEndpointIds', id);
    params.set('offset', String(query.offset));
    params.set('limit', String(query.limit));
    return request(
      `/api/admin/usage-stats/top-tools?${params.toString()}`,
      { method: 'GET' },
      AdminUsageStatsTopToolsListSchema,
    );
  },

  adminPreviewSavedQuery: (id: string): Promise<SavedQueryPreviewResponse> =>
    request(
      `/api/admin/saved-queries/${encodeURIComponent(id)}/preview`,
      { method: 'POST' },
      SavedQueryPreviewResponseSchema,
    ),

  /**
   * 사용자 본인 소유 saved query 의 미리보기. signal 을 전달하면 fetch 중 abort 가능 (모달 unmount 시).
   * DB kind: user_scope_column 행 필터 적용. Excel kind: 본인 소유면 통과.
   * 1000행 / 100컬럼 상한.
   */
  previewSavedQuery: (id: string, signal?: AbortSignal): Promise<SavedQueryPreviewResponse> =>
    request(
      `/api/saved-queries/${encodeURIComponent(id)}/preview`,
      { method: 'POST', signal },
      SavedQueryPreviewResponseSchema,
    ),

  adminFileUploads: (query: AdminFileUploadListQuery): Promise<AdminFileUploadList> => {
    const params = new URLSearchParams();
    if (query.ownerEmail) params.set('ownerEmail', query.ownerEmail);
    if (query.kind) params.set('kind', query.kind);
    if (query.status) params.set('status', query.status);
    if (query.activeOnly) params.set('activeOnly', 'true');
    if (query.mime) params.set('mime', query.mime);
    if (query.orphan) params.set('orphan', query.orphan);
    if (query.from) params.set('from', query.from);
    if (query.to) params.set('to', query.to);
    if (query.cursor) params.set('cursor', query.cursor);
    if (query.limit) params.set('limit', String(query.limit));
    const qs = params.toString();
    return request(
      `/api/admin/file-uploads${qs ? `?${qs}` : ''}`,
      { method: 'GET' },
      AdminFileUploadListSchema,
    );
  },

  adminGetFileUpload: (id: string): Promise<AdminFileUploadListItem> =>
    request(
      `/api/admin/file-uploads/${encodeURIComponent(id)}`,
      { method: 'GET' },
      AdminFileUploadListItemSchema,
    ),

  adminDeleteFileUpload: (
    id: string,
    body: AdminFileUploadDeleteRequest = {},
  ): Promise<AdminFileUploadDeleteResponse> =>
    request(
      `/api/admin/file-uploads/${encodeURIComponent(id)}/delete`,
      { method: 'POST', body: JSON.stringify(body) },
      AdminFileUploadDeleteResponseSchema,
    ),

  adminDeleteOrphanFileUploads: (
    body: AdminFileUploadDeleteOrphansRequest,
  ): Promise<AdminFileUploadDeleteOrphansResponse> =>
    request(
      '/api/admin/file-uploads/delete-orphans',
      { method: 'POST', body: JSON.stringify(body) },
      AdminFileUploadDeleteOrphansResponseSchema,
    ),

  /** 미리보기/다운로드용 — fetch 가 아니라 URL 반환. 이미지/PDF src, a.href 에 그대로 바인딩. */
  adminFileUploadContentUrl: (id: string, inline = true): string =>
    `/api/admin/file-uploads/${encodeURIComponent(id)}/content${inline ? '?inline=1' : ''}`,

  adminFileUploadActiveSummary: (): Promise<AdminFileUploadActiveSummary> =>
    request(
      '/api/admin/file-uploads/active-summary',
      { method: 'GET' },
      AdminFileUploadActiveSummarySchema,
    ),

  adminCancelFileUpload: (id: string, body: AdminFileUploadCancelRequest = {}): Promise<unknown> =>
    request(
      `/api/admin/file-uploads/${encodeURIComponent(id)}/cancel`,
      { method: 'POST', body: JSON.stringify(body) },
      z.unknown(),
    ),

  adminAttachmentsBySession: (
    query: AdminAttachmentBySessionQuery,
  ): Promise<AdminAttachmentBySession> => {
    const params = new URLSearchParams();
    if (query.ownerEmail) params.set('ownerEmail', query.ownerEmail);
    if (query.sessionId) params.set('sessionId', query.sessionId);
    if (query.cursor) params.set('cursor', query.cursor);
    if (query.limit) params.set('limit', String(query.limit));
    const qs = params.toString();
    return request(
      `/api/admin/file-uploads/by-session${qs ? `?${qs}` : ''}`,
      { method: 'GET' },
      AdminAttachmentBySessionSchema,
    );
  },

  adminGetDocumentSettings: (): Promise<DocumentProcessingConfig> =>
    request('/api/admin/file-uploads/settings', { method: 'GET' }, DocumentProcessingConfigSchema),

  adminUpdateDocumentSettings: (
    body: DocumentProcessingConfigUpdate,
  ): Promise<DocumentProcessingConfig> =>
    request(
      '/api/admin/file-uploads/settings',
      { method: 'POST', body: JSON.stringify(body) },
      DocumentProcessingConfigSchema,
    ),

  adminLlmList: (): Promise<LlmEndpointList> =>
    request('/api/admin/llm-endpoints', { method: 'GET' }, LlmEndpointListSchema),

  adminLlmGet: (id: string): Promise<LlmEndpoint> =>
    request(
      `/api/admin/llm-endpoints/${encodeURIComponent(id)}`,
      { method: 'GET' },
      LlmEndpointSchema,
    ),

  adminLlmCreate: (body: CreateLlmEndpointRequest): Promise<LlmEndpoint> =>
    request(
      '/api/admin/llm-endpoints',
      { method: 'POST', body: JSON.stringify(body) },
      LlmEndpointSchema,
    ),

  adminLlmUpdate: (id: string, body: UpdateLlmEndpointRequest): Promise<LlmEndpoint> =>
    request(
      `/api/admin/llm-endpoints/${encodeURIComponent(id)}/update`,
      { method: 'POST', body: JSON.stringify(body) },
      LlmEndpointSchema,
    ),

  adminLlmDelete: (id: string): Promise<null> =>
    request(
      `/api/admin/llm-endpoints/${encodeURIComponent(id)}/delete`,
      { method: 'POST' },
      z.null(),
    ),

  adminLlmProbe: (id: string): Promise<ProbeResponse> =>
    request(
      `/api/admin/llm-endpoints/${encodeURIComponent(id)}/probe`,
      { method: 'POST' },
      ProbeResponseSchema,
    ),

  adminLlmProbeDraft: (body: ProbeDraftRequest): Promise<ProbeResponse> =>
    request(
      '/api/admin/llm-endpoints/probe-draft',
      { method: 'POST', body: JSON.stringify(body) },
      ProbeResponseSchema,
    ),

  adminLlmProbeAll: (): Promise<ProbeAllResponse> =>
    request('/api/admin/llm-endpoints/probe-all', { method: 'POST' }, ProbeAllResponseSchema),

  /** 엔드포인트별 동시성 슬롯 현황 (admin 모니터링, 짧은 주기 폴링). */
  adminLlmConcurrency: (): Promise<LlmConcurrencyStatus> =>
    request('/api/admin/llm-concurrency', { method: 'GET' }, LlmConcurrencyStatusSchema),

  /** 슬롯 단위 상세 (안 풀리는 슬롯 진단용). 모달 열렸을 때만 짧은 주기 폴링. */
  adminLlmConcurrencySlots: (): Promise<LlmConcurrencySlotsResponse> =>
    request(
      '/api/admin/llm-concurrency/slots',
      { method: 'GET' },
      LlmConcurrencySlotsResponseSchema,
    ),

  /** 특정 슬롯 강제 해제 (만료 여부 무관). */
  adminLlmConcurrencyRelease: (token: string): Promise<{ ok: boolean }> =>
    request(
      '/api/admin/llm-concurrency/release',
      { method: 'POST', body: JSON.stringify({ token }) },
      z.object({ ok: z.boolean() }),
    ),

  /** 만료(stale) 슬롯 즉시 회수. */
  adminLlmConcurrencySweep: (): Promise<{ ok: boolean; removed: number }> =>
    request(
      '/api/admin/llm-concurrency/sweep',
      { method: 'POST' },
      z.object({ ok: z.boolean(), removed: z.number() }),
    ),

  /* ── LLM Bonding ──────────────────────────────────────────────── */

  adminLlmBondingList: (): Promise<LlmBondingList> =>
    request('/api/admin/llm-bondings', { method: 'GET' }, LlmBondingListSchema),

  adminLlmBondingGet: (id: string): Promise<LlmBondingDetail> =>
    request(
      `/api/admin/llm-bondings/${encodeURIComponent(id)}`,
      { method: 'GET' },
      LlmBondingDetailSchema,
    ),

  adminLlmBondingCreate: (body: CreateLlmBondingRequest): Promise<LlmBonding> =>
    request(
      '/api/admin/llm-bondings',
      { method: 'POST', body: JSON.stringify(body) },
      LlmBondingSchema,
    ),

  adminLlmBondingUpdate: (id: string, body: UpdateLlmBondingRequest): Promise<LlmBonding> =>
    request(
      `/api/admin/llm-bondings/${encodeURIComponent(id)}/update`,
      { method: 'POST', body: JSON.stringify(body) },
      LlmBondingSchema,
    ),

  adminLlmBondingDelete: (id: string): Promise<null> =>
    request(
      `/api/admin/llm-bondings/${encodeURIComponent(id)}/delete`,
      { method: 'POST' },
      z.null(),
    ),

  adminLlmBondingProbe: (id: string): Promise<LlmBondingProbeResponse> =>
    request(
      `/api/admin/llm-bondings/${encodeURIComponent(id)}/probe`,
      { method: 'POST' },
      LlmBondingProbeResponseSchema,
    ),

  adminLlmBondingProbeDraft: (
    body: LlmBondingProbeDraftRequest,
  ): Promise<LlmBondingProbeResponse> =>
    request(
      '/api/admin/llm-bondings/probe-draft',
      { method: 'POST', body: JSON.stringify(body) },
      LlmBondingProbeResponseSchema,
    ),

  adminLlmBondingProbeAll: (): Promise<ProbeAllResponse> =>
    request('/api/admin/llm-bondings/probe-all', { method: 'POST' }, ProbeAllResponseSchema),

  adminLlmBondingRemoveMember: (
    id: string,
    body: RemoveBondingMemberRequest,
  ): Promise<LlmBonding> =>
    request(
      `/api/admin/llm-bondings/${encodeURIComponent(id)}/remove-member`,
      { method: 'POST', body: JSON.stringify(body) },
      LlmBondingSchema,
    ),

  adminSkillList: (): Promise<SkillList> =>
    request('/api/admin/skills', { method: 'GET' }, SkillListSchema),

  adminSkillGet: (id: string): Promise<Skill> =>
    request(`/api/admin/skills/${encodeURIComponent(id)}`, { method: 'GET' }, SkillSchema),

  adminSkillCreate: (body: CreateSkillRequest): Promise<Skill> =>
    request('/api/admin/skills', { method: 'POST', body: JSON.stringify(body) }, SkillSchema),

  adminSkillUpdate: (id: string, body: UpdateSkillRequest): Promise<Skill> =>
    request(
      `/api/admin/skills/${encodeURIComponent(id)}/update`,
      { method: 'POST', body: JSON.stringify(body) },
      SkillSchema,
    ),

  adminSkillDelete: (id: string): Promise<null> =>
    request(`/api/admin/skills/${encodeURIComponent(id)}/delete`, { method: 'POST' }, z.null()),

  // ── Agents (외부 임베드용) ──
  adminAgentList: (): Promise<ListAdminAgentsResponse> =>
    request('/api/admin/agents', { method: 'GET' }, ListAdminAgentsResponseSchema),

  adminAgentGet: (id: string): Promise<AgentSummary> =>
    request(`/api/admin/agents/${encodeURIComponent(id)}`, { method: 'GET' }, AgentSummarySchema),

  adminAgentCreate: (body: CreateAdminAgentRequest): Promise<AgentSummary> =>
    request(
      '/api/admin/agents',
      { method: 'POST', body: JSON.stringify(body) },
      AgentSummarySchema,
    ),

  adminAgentUpdate: (id: string, body: UpdateAdminAgentRequest): Promise<AgentSummary> =>
    request(
      `/api/admin/agents/${encodeURIComponent(id)}/update`,
      { method: 'POST', body: JSON.stringify(body) },
      AgentSummarySchema,
    ),

  adminAgentDelete: (id: string): Promise<{ ok: boolean }> =>
    request(`/api/admin/agents/${encodeURIComponent(id)}/delete`, { method: 'POST' }, OkSchema),

  adminAgentKeyList: (id: string): Promise<ListAgentApiKeysResponse> =>
    request(
      `/api/admin/agents/${encodeURIComponent(id)}/keys`,
      { method: 'GET' },
      ListAgentApiKeysResponseSchema,
    ),

  adminAgentKeyCreate: (
    id: string,
    body: CreateAgentApiKeyRequest,
  ): Promise<CreateAgentApiKeyResponse> =>
    request(
      `/api/admin/agents/${encodeURIComponent(id)}/keys`,
      { method: 'POST', body: JSON.stringify(body) },
      CreateAgentApiKeyResponseSchema,
    ),

  adminAgentKeyRevoke: (id: string, keyId: string): Promise<{ ok: boolean }> =>
    request(
      `/api/admin/agents/${encodeURIComponent(id)}/keys/${encodeURIComponent(keyId)}/revoke`,
      { method: 'POST' },
      OkSchema,
    ),

  adminAgentKeyDelete: (id: string, keyId: string): Promise<{ ok: boolean }> =>
    request(
      `/api/admin/agents/${encodeURIComponent(id)}/keys/${encodeURIComponent(keyId)}/delete`,
      { method: 'POST' },
      OkSchema,
    ),

  // ── Skill helpers ──

  adminSkillLessonsIncorporate: (
    skillId: string,
    body: IncorporateLessonsRequest,
  ): Promise<IncorporateLessonsProposal> =>
    request(
      `/api/admin/skills/${encodeURIComponent(skillId)}/lessons/incorporate`,
      { method: 'POST', body: JSON.stringify(body) },
      IncorporateLessonsProposalSchema,
    ),

  adminSkillLessonsIncorporateCommit: (
    skillId: string,
    body: IncorporateLessonsCommitRequest,
  ): Promise<Skill> =>
    request(
      `/api/admin/skills/${encodeURIComponent(skillId)}/lessons/incorporate/commit`,
      { method: 'POST', body: JSON.stringify(body) },
      SkillSchema,
    ),

  adminSkillAuditCommit: (skillId: string, body: AuditSkillCommitRequest): Promise<Skill> =>
    request(
      `/api/admin/skills/${encodeURIComponent(skillId)}/audit/commit`,
      { method: 'POST', body: JSON.stringify(body) },
      SkillSchema,
    ),

  adminSkillAuditStart: (skillId: string): Promise<StartSkillAuditResponse> =>
    request(
      `/api/admin/skills/${encodeURIComponent(skillId)}/audit-with-ai`,
      { method: 'POST', body: '{}' },
      StartSkillAuditResponseSchema,
    ),

  adminSkillAuditRunsLatest: (skillId: string): Promise<SkillAuditRunLatest> =>
    request(
      `/api/admin/skills/${encodeURIComponent(skillId)}/audit-runs/latest`,
      { method: 'GET' },
      SkillAuditRunLatestSchema,
    ),

  adminSkillAuditRunGet: (skillId: string, runId: string): Promise<SkillAuditRun> =>
    request(
      `/api/admin/skills/${encodeURIComponent(skillId)}/audit-runs/${encodeURIComponent(runId)}`,
      { method: 'GET' },
      SkillAuditRunSchema,
    ),

  adminSkillAuditRunCancel: (skillId: string, runId: string): Promise<SkillAuditRun> =>
    request(
      `/api/admin/skills/${encodeURIComponent(skillId)}/audit-runs/${encodeURIComponent(runId)}/cancel`,
      { method: 'POST', body: '{}' },
      SkillAuditRunSchema,
    ),

  adminSkillPromptVersionsList: (skillId: string): Promise<SkillPromptVersionList> =>
    request(
      `/api/admin/skills/${encodeURIComponent(skillId)}/prompt-versions`,
      { method: 'GET' },
      SkillPromptVersionListSchema,
    ),

  adminSkillPromptVersionRestore: (
    skillId: string,
    versionId: string,
  ): Promise<SkillPromptVersion> =>
    request(
      `/api/admin/skills/${encodeURIComponent(skillId)}/prompt-versions/${encodeURIComponent(versionId)}/restore`,
      { method: 'POST' },
      SkillPromptVersionSchema,
    ),

  // ── 시스템 프롬프트 (관리자 편집 + 이력) ──
  adminSystemPromptList: (): Promise<SystemPromptSummaryList> =>
    request('/api/admin/system-prompts', { method: 'GET' }, SystemPromptSummaryListSchema),

  adminSystemPromptGet: (key: string): Promise<SystemPromptDetail> =>
    request(
      `/api/admin/system-prompts/${encodeURIComponent(key)}`,
      { method: 'GET' },
      SystemPromptDetailSchema,
    ),

  adminSystemPromptSave: (
    key: string,
    body: { value: string; changelog?: string },
  ): Promise<{ ok: boolean }> =>
    request(
      `/api/admin/system-prompts/${encodeURIComponent(key)}/save`,
      { method: 'POST', body: JSON.stringify(body) },
      z.object({ ok: z.boolean() }),
    ),

  adminSystemPromptRestoreDefault: (
    key: string,
    body?: { changelog?: string },
  ): Promise<{ ok: boolean }> =>
    request(
      `/api/admin/system-prompts/${encodeURIComponent(key)}/restore-default`,
      { method: 'POST', body: JSON.stringify(body ?? {}) },
      z.object({ ok: z.boolean() }),
    ),

  adminSystemPromptVersionsList: (key: string): Promise<SystemPromptVersionList> =>
    request(
      `/api/admin/system-prompts/${encodeURIComponent(key)}/versions`,
      { method: 'GET' },
      SystemPromptVersionListSchema,
    ),

  adminHttpEndpointList: (): Promise<HttpEndpointList> =>
    request('/api/admin/http-endpoints', { method: 'GET' }, HttpEndpointListSchema),

  adminHttpEndpointGet: (id: string): Promise<HttpEndpoint> =>
    request(
      `/api/admin/http-endpoints/${encodeURIComponent(id)}`,
      { method: 'GET' },
      HttpEndpointSchema,
    ),

  adminHttpEndpointCreate: (body: CreateHttpEndpointRequest): Promise<HttpEndpoint> =>
    request(
      '/api/admin/http-endpoints',
      { method: 'POST', body: JSON.stringify(body) },
      HttpEndpointSchema,
    ),

  adminHttpEndpointUpdate: (id: string, body: UpdateHttpEndpointRequest): Promise<HttpEndpoint> =>
    request(
      `/api/admin/http-endpoints/${encodeURIComponent(id)}/update`,
      { method: 'POST', body: JSON.stringify(body) },
      HttpEndpointSchema,
    ),

  adminHttpEndpointDelete: (id: string): Promise<null> =>
    request(
      `/api/admin/http-endpoints/${encodeURIComponent(id)}/delete`,
      { method: 'POST' },
      z.null(),
    ),

  adminHttpEndpointTest: (id: string): Promise<TestHttpEndpointResponse> =>
    request(
      `/api/admin/http-endpoints/${encodeURIComponent(id)}/test`,
      { method: 'POST' },
      TestHttpEndpointResponseSchema,
    ),

  adminBannedKeywordList: (): Promise<BannedKeywordList> =>
    request('/api/admin/banned-keywords', { method: 'GET' }, BannedKeywordListSchema),

  adminBannedKeywordCreate: (body: CreateBannedKeywordRequest): Promise<BannedKeyword> =>
    request(
      '/api/admin/banned-keywords',
      { method: 'POST', body: JSON.stringify(body) },
      BannedKeywordSchema,
    ),

  adminBannedKeywordUpdate: (
    id: string,
    body: UpdateBannedKeywordRequest,
  ): Promise<BannedKeyword> =>
    request(
      `/api/admin/banned-keywords/${encodeURIComponent(id)}/update`,
      { method: 'POST', body: JSON.stringify(body) },
      BannedKeywordSchema,
    ),

  adminBannedKeywordDelete: (id: string): Promise<null> =>
    request(
      `/api/admin/banned-keywords/${encodeURIComponent(id)}/delete`,
      { method: 'POST' },
      z.null(),
    ),

  adminFamilySiteList: (): Promise<AdminFamilySiteList> =>
    request('/api/admin/family-sites', { method: 'GET' }, AdminFamilySiteListSchema),

  adminFamilySiteCreate: (body: CreateFamilySiteRequest): Promise<AdminFamilySite> =>
    request(
      '/api/admin/family-sites',
      { method: 'POST', body: JSON.stringify(body) },
      AdminFamilySiteSchema,
    ),

  adminFamilySiteUpdate: (id: string, body: UpdateFamilySiteRequest): Promise<AdminFamilySite> =>
    request(
      `/api/admin/family-sites/${encodeURIComponent(id)}/update`,
      { method: 'POST', body: JSON.stringify(body) },
      AdminFamilySiteSchema,
    ),

  adminFamilySiteDelete: (id: string): Promise<null> =>
    request(
      `/api/admin/family-sites/${encodeURIComponent(id)}/delete`,
      { method: 'POST' },
      z.null(),
    ),

  adminFamilySiteUploadLogo: async (id: string, file: File): Promise<AdminFamilySite> => {
    const fd = new FormData();
    fd.append('file', file, file.name);
    const res = await fetch(`/api/admin/family-sites/${encodeURIComponent(id)}/upload-logo`, {
      method: 'POST',
      credentials: 'include',
      body: fd,
    });
    const text = await res.text();
    const json = text ? JSON.parse(text) : null;
    if (!res.ok) {
      const parsed = ApiErrorSchema.safeParse(json);
      if (parsed.success) {
        throw new ApiError(
          res.status,
          parsed.data.error.code,
          parsed.data.error.message,
          parsed.data.error.details,
        );
      }
      throw new ApiError(res.status, 'INTERNAL', `로고 업로드 실패 (${res.status})`);
    }
    return AdminFamilySiteSchema.parse(json);
  },

  adminFamilySiteReorder: (body: ReorderFamilySitesRequest): Promise<AdminFamilySiteList> =>
    request(
      '/api/admin/family-sites/reorder',
      { method: 'POST', body: JSON.stringify(body) },
      AdminFamilySiteListSchema,
    ),

  familySiteList: (): Promise<PublicFamilySiteList> =>
    request('/api/family-sites', { method: 'GET' }, PublicFamilySiteListSchema),

  chatModels: (): Promise<ChatModelList> =>
    request('/api/chat/models', { method: 'GET' }, ChatModelListSchema),

  chatSetSessionModel: (id: string, body: SetChatSessionModelRequest): Promise<ChatSession> =>
    request(
      `/api/chat/sessions/${encodeURIComponent(id)}/model`,
      { method: 'POST', body: JSON.stringify(body) },
      ChatSessionSchema,
    ),

  chatSessionList: (): Promise<ChatSessionList> =>
    request('/api/chat/sessions', { method: 'GET' }, ChatSessionListSchema),

  chatCreateSession: (body?: CreateChatSessionRequest): Promise<CreateChatSessionResponse> =>
    request(
      '/api/chat/sessions',
      { method: 'POST', body: body ? JSON.stringify(body) : undefined },
      CreateChatSessionResponseSchema,
    ),

  chatGetSession: (id: string): Promise<ChatSessionDetail> =>
    request(
      `/api/chat/sessions/${encodeURIComponent(id)}`,
      { method: 'GET' },
      ChatSessionDetailSchema,
    ),

  chatDeleteSession: (id: string): Promise<null> =>
    request(`/api/chat/sessions/${encodeURIComponent(id)}/delete`, { method: 'POST' }, z.null()),

  /**
   * 대화 압축 — 옛 메시지를 LLM 으로 요약 → archived 마킹. 95%+ 도달 시 헤더 chip 옆 버튼이 호출.
   * 응답: 새로 생성된 summary 메시지 id + 요약된 메시지 수 + 요약 글자 수.
   */
  chatCompactSession: (
    id: string,
  ): Promise<{
    ok: true;
    summaryId: string;
    summarizedCount: number;
    summaryChars: number;
    archivedAt: string;
  }> =>
    request(
      `/api/chat/sessions/${encodeURIComponent(id)}/compact`,
      { method: 'POST' },
      z.object({
        ok: z.literal(true),
        summaryId: z.string().uuid(),
        summarizedCount: z.number().int(),
        summaryChars: z.number().int(),
        archivedAt: z.string(),
      }),
    ),

  chatRenameSession: (id: string, body: RenameChatSessionRequest): Promise<ChatSession> =>
    request(
      `/api/chat/sessions/${encodeURIComponent(id)}/rename`,
      { method: 'POST', body: JSON.stringify(body) },
      ChatSessionSchema,
    ),

  chatToggleFavorite: (id: string, body: ToggleChatSessionFavoriteRequest): Promise<ChatSession> =>
    request(
      `/api/chat/sessions/${encodeURIComponent(id)}/favorite`,
      { method: 'POST', body: JSON.stringify(body) },
      ChatSessionSchema,
    ),

  chatMoveSession: (id: string, body: MoveChatSessionRequest): Promise<ChatSession> =>
    request(
      `/api/chat/sessions/${encodeURIComponent(id)}/move`,
      { method: 'POST', body: JSON.stringify(body) },
      ChatSessionSchema,
    ),

  /** 채팅 상단 chip — 현재 활성 skill 목록 (chat_sessions.skillIds). */
  chatGetActiveSkills: (id: string): Promise<ActiveSessionSkillsResponse> =>
    request(
      `/api/chat/sessions/${encodeURIComponent(id)}/skills`,
      { method: 'GET' },
      ActiveSessionSkillsResponseSchema,
    ),

  /** 사용자가 chip 으로 활성 skill add/remove. 응답으로 갱신된 활성 목록 반환. */
  chatUpdateActiveSkills: (
    id: string,
    body: UpdateSessionSkillsRequest,
  ): Promise<ActiveSessionSkillsResponse> =>
    request(
      `/api/chat/sessions/${encodeURIComponent(id)}/skills/update`,
      { method: 'POST', body: JSON.stringify(body) },
      ActiveSessionSkillsResponseSchema,
    ),

  chatProjectList: (): Promise<ChatProjectList> =>
    request('/api/chat/projects', { method: 'GET' }, ChatProjectListSchema),

  chatProjectCreate: (body: CreateChatProjectRequest): Promise<ChatProject> =>
    request(
      '/api/chat/projects',
      { method: 'POST', body: JSON.stringify(body) },
      ChatProjectSchema,
    ),

  chatProjectRename: (id: string, body: RenameChatProjectRequest): Promise<ChatProject> =>
    request(
      `/api/chat/projects/${encodeURIComponent(id)}/rename`,
      { method: 'POST', body: JSON.stringify(body) },
      ChatProjectSchema,
    ),

  chatProjectDelete: (id: string): Promise<null> =>
    request(`/api/chat/projects/${encodeURIComponent(id)}/delete`, { method: 'POST' }, z.null()),

  /** 진행 중 응답 중단 — 정지 버튼이 호출. active run 이 없으면 canceled=false. */
  chatCancelStream: (sessionId: string): Promise<{ canceled: boolean }> =>
    request(
      `/api/chat/sessions/${encodeURIComponent(sessionId)}/cancel`,
      { method: 'POST' },
      z.object({ canceled: z.boolean() }),
    ),

  /** 채팅 화면 마운트 시 호출 — 새로고침 직후 모달 복구용. 활성 인터럽트가 없으면 null. */
  chatGetActiveInterrupt: (sessionId: string): Promise<ActiveInterrupt | null> =>
    request(
      `/api/chat/sessions/${encodeURIComponent(sessionId)}/interrupts/active`,
      { method: 'GET' },
      ActiveInterruptSchema.nullable(),
    ),

  artifactSessionList: (sessionId: string): Promise<ArtifactList> =>
    request(
      `/api/artifacts/session/${encodeURIComponent(sessionId)}`,
      { method: 'GET' },
      ArtifactListSchema,
    ),

  artifactGet: (id: string): Promise<ArtifactDetail> =>
    request(`/api/artifacts/${encodeURIComponent(id)}`, { method: 'GET' }, ArtifactDetailSchema),

  artifactGetVersion: (id: string, version: number): Promise<ArtifactVersion> =>
    request(
      `/api/artifacts/${encodeURIComponent(id)}/versions/${version}`,
      { method: 'GET' },
      ArtifactVersionSchema,
    ),

  /**
   * iframe artifact 의 `window.artifact.*` 호출을 부모 윈도우가 서버로 프록시할 때 사용.
   * 서버는 `method` 를 기존 SkillToolKey 로 매핑해 `runTool()` 로 실행 — 채팅과 동일한 권한/감사 경로.
   */
  artifactRpc: (
    id: string,
    method: ArtifactRpcMethod,
    params: unknown,
  ): Promise<ArtifactRpcResponse> =>
    request(
      `/api/artifacts/${encodeURIComponent(id)}/rpc`,
      { method: 'POST', body: JSON.stringify({ method, params }) },
      ArtifactRpcResponseSchema,
    ),

  /**
   * 채팅 대시보드 아티팩트의 수동 편집 영속화 (fire-and-forget).
   * iframe 이 mutate 한 full spec + 현재 버전을 보내 서버가 재렌더 후 그 버전 content +
   * dashboard_specs 를 in-place 갱신 → 모델 dashboard.edit 인덱스가 수동 편집을 반영.
   */
  artifactSetDashboardSpec: (
    id: string,
    body: ArtifactDashboardSpecRequest,
  ): Promise<{ ok: boolean }> =>
    request(
      `/api/artifacts/${encodeURIComponent(id)}/dashboard-spec`,
      { method: 'POST', body: JSON.stringify(body) },
      z.object({ ok: z.boolean() }),
    ),

  /** 관리자 검토용 — 타 사용자 세션의 artifact 버전 본문 (소유권 검증 없이, 만료 판정은 소유자 기준). */
  adminArtifactGetVersion: (
    sessionId: string,
    artifactId: string,
    version: number,
  ): Promise<ArtifactVersion> =>
    request(
      `/api/admin/chat-sessions/${encodeURIComponent(sessionId)}/artifacts/${encodeURIComponent(artifactId)}/versions/${version}`,
      { method: 'GET' },
      ArtifactVersionSchema,
    ),

  /** 관리자 검토용 artifact RPC — 세션 소유자 스코프로 실행 (사용자가 본 데이터 재현). */
  adminArtifactRpc: (
    sessionId: string,
    artifactId: string,
    method: ArtifactRpcMethod,
    params: unknown,
  ): Promise<ArtifactRpcResponse> =>
    request(
      `/api/admin/chat-sessions/${encodeURIComponent(sessionId)}/artifacts/${encodeURIComponent(artifactId)}/rpc`,
      { method: 'POST', body: JSON.stringify({ method, params }) },
      ArtifactRpcResponseSchema,
    ),

  fileList: (sessionId?: string): Promise<FileUploadList> => {
    const qs = sessionId ? `?sessionId=${encodeURIComponent(sessionId)}` : '';
    return request(`/api/files${qs}`, { method: 'GET' }, FileUploadListSchema);
  },

  fileUpload: async (file: File): Promise<FileUpload> => {
    const fd = new FormData();
    fd.append('file', file, file.name);
    // FormData 사용 시 Content-Type 헤더 직접 설정 금지 — fetch 가 boundary 포함해 자동 생성.
    const res = await fetch('/api/files/upload', {
      method: 'POST',
      credentials: 'include',
      body: fd,
    });
    const text = await res.text();
    const json = text ? JSON.parse(text) : null;
    if (!res.ok) {
      const parsed = ApiErrorSchema.safeParse(json);
      if (parsed.success) {
        throw new ApiError(
          res.status,
          parsed.data.error.code,
          parsed.data.error.message,
          parsed.data.error.details,
        );
      }
      throw new ApiError(res.status, 'INTERNAL', `업로드 실패 (${res.status})`);
    }
    return FileUploadSchema.parse(json);
  },

  fileDelete: (id: string): Promise<null> =>
    request(`/api/files/${encodeURIComponent(id)}`, { method: 'DELETE' }, z.null()),

  /** 진행 중(업로드/대기/변환) 첨부의 사용자 중지. */
  fileCancel: (id: string): Promise<FileUpload> =>
    request(`/api/files/${encodeURIComponent(id)}/cancel`, { method: 'POST' }, FileUploadSchema),

  dataSourceList: (): Promise<DataSourceList> =>
    request('/api/admin/data-sources', { method: 'GET' }, DataSourceListSchema),

  dataSourceGet: (id: string): Promise<DataSource> =>
    request(
      `/api/admin/data-sources/${encodeURIComponent(id)}`,
      { method: 'GET' },
      DataSourceSchema,
    ),

  dataSourceCreate: (body: CreateDataSourceRequest): Promise<DataSource> =>
    request(
      '/api/admin/data-sources',
      { method: 'POST', body: JSON.stringify(body) },
      DataSourceSchema,
    ),

  dataSourceUpdate: (id: string, body: UpdateDataSourceRequest): Promise<DataSource> =>
    request(
      `/api/admin/data-sources/${encodeURIComponent(id)}/update`,
      { method: 'POST', body: JSON.stringify(body) },
      DataSourceSchema,
    ),

  dataSourceDelete: (id: string): Promise<null> =>
    request(
      `/api/admin/data-sources/${encodeURIComponent(id)}/delete`,
      { method: 'POST' },
      z.null(),
    ),

  /** 엑셀 데이터소스 — 등록 전 PK 중복 사전 검증. */
  dataSourceExcelCheckPkDuplicates: (
    body: ExcelCheckPkDuplicatesRequest,
  ): Promise<ExcelCheckPkDuplicatesResponse> =>
    request(
      '/api/admin/data-sources/excel/check-pk-duplicates',
      { method: 'POST', body: JSON.stringify(body) },
      ExcelCheckPkDuplicatesResponseSchema,
    ),

  dataSourceTestConnection: (body: TestConnectionRequest): Promise<TestConnectionResponse> =>
    request(
      '/api/admin/data-sources/test-connection',
      { method: 'POST', body: JSON.stringify(body) },
      TestConnectionResponseSchema,
    ),

  dataSourceTestConnectionById: (
    id: string,
    body: UpdateDataSourceRequest,
  ): Promise<TestConnectionResponse> =>
    request(
      `/api/admin/data-sources/${encodeURIComponent(id)}/test-connection`,
      { method: 'POST', body: JSON.stringify(body) },
      TestConnectionResponseSchema,
    ),

  dataSourceSync: (id: string, body: SyncRequest): Promise<SyncResponse> =>
    request(
      `/api/admin/data-sources/${encodeURIComponent(id)}/sync`,
      { method: 'POST', body: JSON.stringify(body) },
      SyncResponseSchema,
    ),

  dataSourceSyncCancel: (id: string): Promise<SyncCancelResponse> =>
    request(
      `/api/admin/data-sources/${encodeURIComponent(id)}/sync/cancel`,
      { method: 'POST' },
      SyncCancelResponseSchema,
    ),

  dataSourceGenerateDescriptions: (id: string): Promise<GenerateDescriptionsResponse> =>
    request(
      `/api/admin/data-sources/${encodeURIComponent(id)}/generate-descriptions`,
      { method: 'POST' },
      GenerateDescriptionsResponseSchema,
    ),

  dataSourceJobs: (id: string): Promise<DataSourceJobsResponse> =>
    request(
      `/api/admin/data-sources/${encodeURIComponent(id)}/jobs`,
      { method: 'GET' },
      DataSourceJobsResponseSchema,
    ),

  // ─── Tableau 데이터소스 ──────────────────────────────────
  tableauTestConnection: (body: TestTableauConnectionRequest): Promise<TestConnectionResponse> =>
    request(
      '/api/admin/data-sources/tableau/test-connection',
      { method: 'POST', body: JSON.stringify(body) },
      TestConnectionResponseSchema,
    ),
  tableauCreate: (body: CreateTableauDataSourceRequest): Promise<{ id: string }> =>
    request(
      '/api/admin/data-sources/tableau',
      { method: 'POST', body: JSON.stringify(body) },
      z.object({ id: z.string().uuid() }),
    ),
  tableauUpdate: (id: string, body: UpdateTableauDataSourceRequest): Promise<{ ok: boolean }> =>
    request(
      `/api/admin/data-sources/tableau/${encodeURIComponent(id)}/update`,
      { method: 'POST', body: JSON.stringify(body) },
      z.object({ ok: z.boolean() }),
    ),
  tableauResourcesList: (id: string): Promise<TableauResourceListResponse> =>
    request(
      `/api/admin/data-sources/${encodeURIComponent(id)}/tableau/resources`,
      { method: 'GET' },
      TableauResourceListResponseSchema,
    ),
  tableauResourceIntegrate: (
    id: string,
    resId: string,
    body: IntegrateTableauResourceRequest = {},
  ): Promise<IntegrateTableauResourceResponse> =>
    request(
      `/api/admin/data-sources/${encodeURIComponent(id)}/tableau/resources/${encodeURIComponent(
        resId,
      )}/integrate`,
      { method: 'POST', body: JSON.stringify(body ?? {}) },
      IntegrateTableauResourceResponseSchema,
    ),
  tableauResourceSchedule: (
    id: string,
    resId: string,
    body: SetTableauScheduleRequest,
  ): Promise<{ ok: boolean }> =>
    request(
      `/api/admin/data-sources/${encodeURIComponent(id)}/tableau/resources/${encodeURIComponent(
        resId,
      )}/schedule`,
      { method: 'POST', body: JSON.stringify(body) },
      z.object({ ok: z.boolean() }),
    ),
  tableauResourceDescription: (
    id: string,
    resId: string,
    body: UpdateTableauResourceDescriptionRequest,
  ): Promise<{ ok: boolean }> =>
    request(
      `/api/admin/data-sources/${encodeURIComponent(id)}/tableau/resources/${encodeURIComponent(
        resId,
      )}/description`,
      { method: 'POST', body: JSON.stringify(body) },
      z.object({ ok: z.boolean() }),
    ),
  tableauResourceDelete: (id: string, resId: string): Promise<{ ok: boolean }> =>
    request(
      `/api/admin/data-sources/${encodeURIComponent(id)}/tableau/resources/${encodeURIComponent(
        resId,
      )}/delete`,
      { method: 'POST', body: '{}' },
      z.object({ ok: z.boolean() }),
    ),
  /** duckdb DS 의 부모 Tableau 자원 + 자동 Skill 조회. 결과로 duckdb DS 상세에 액션 박스 미러링. */
  dataSourceTableauSource: (id: string): Promise<DuckdbTableauSourceResponse> =>
    request(
      `/api/admin/data-sources/${encodeURIComponent(id)}/tableau-source`,
      { method: 'GET' },
      DuckdbTableauSourceResponseSchema,
    ),

  adminJobsList: (): Promise<ServerJobList> =>
    request('/api/admin/jobs', { method: 'GET' }, ServerJobListSchema),

  adminJobCancel: (jobId: string): Promise<CancelServerJobResponse> =>
    request(
      `/api/admin/jobs/${encodeURIComponent(jobId)}/cancel`,
      { method: 'POST' },
      CancelServerJobResponseSchema,
    ),

  adminJobDelete: (jobId: string): Promise<DeleteServerJobResponse> =>
    request(
      `/api/admin/jobs/${encodeURIComponent(jobId)}/delete`,
      { method: 'POST' },
      DeleteServerJobResponseSchema,
    ),

  dataSourceTableList: (id: string): Promise<DataSourceTableList> =>
    request(
      `/api/admin/data-sources/${encodeURIComponent(id)}/tables`,
      { method: 'GET' },
      DataSourceTableListSchema,
    ),

  dataSourceTableGet: (id: string, tableId: string): Promise<DataSourceTableDetail> =>
    request(
      `/api/admin/data-sources/${encodeURIComponent(id)}/tables/${encodeURIComponent(tableId)}`,
      { method: 'GET' },
      DataSourceTableDetailSchema,
    ),

  dataSourceTablePreview: (
    id: string,
    tableId: string,
    signal?: AbortSignal,
  ): Promise<DataSourceTablePreviewResponse> =>
    request(
      `/api/admin/data-sources/${encodeURIComponent(id)}/tables/${encodeURIComponent(tableId)}/preview`,
      { method: 'POST', signal },
      DataSourceTablePreviewResponseSchema,
    ),

  dataSourceUpdateTable: (
    id: string,
    tableId: string,
    body: UpdateTableDescriptionRequest,
  ): Promise<DataSourceTableDetail> =>
    request(
      `/api/admin/data-sources/${encodeURIComponent(id)}/tables/${encodeURIComponent(tableId)}/update`,
      { method: 'POST', body: JSON.stringify(body) },
      DataSourceTableDetailSchema,
    ),

  dataSourceSetTableUserScope: (
    id: string,
    tableId: string,
    body: UpdateTableUserScopeRequest,
  ): Promise<DataSourceTableDetail> =>
    request(
      `/api/admin/data-sources/${encodeURIComponent(id)}/tables/${encodeURIComponent(tableId)}/user-scope`,
      { method: 'POST', body: JSON.stringify(body) },
      DataSourceTableDetailSchema,
    ),

  dataSourceUpdateColumn: (
    id: string,
    tableId: string,
    columnId: string,
    body: UpdateColumnDescriptionRequest,
  ) =>
    request(
      `/api/admin/data-sources/${encodeURIComponent(id)}/tables/${encodeURIComponent(tableId)}/columns/${encodeURIComponent(columnId)}/update`,
      { method: 'POST', body: JSON.stringify(body) },
      // 응답은 단일 컬럼이지만 type 강제 할 필요 없이 Detail 다시 fetch 권장 → unknown 으로 받음
      z.unknown(),
    ),

  adminSkillLessonsList: (
    query: SkillLessonListQuery = { limit: 50 },
  ): Promise<SkillLessonList> => {
    const params = new URLSearchParams();
    if (query.status) params.set('status', query.status);
    if (query.skillId) params.set('skillId', query.skillId);
    if (query.cursor) params.set('cursor', query.cursor);
    if (query.limit) params.set('limit', String(query.limit));
    const qs = params.toString();
    return request(
      `/api/admin/skill-lessons${qs ? `?${qs}` : ''}`,
      { method: 'GET' },
      SkillLessonListSchema,
    );
  },

  adminSkillLessonGet: (id: string): Promise<SkillLesson> =>
    request(
      `/api/admin/skill-lessons/${encodeURIComponent(id)}`,
      { method: 'GET' },
      SkillLessonSchema,
    ),

  adminSkillLessonUpdate: (id: string, body: UpdateSkillLessonRequest): Promise<SkillLesson> =>
    request(
      `/api/admin/skill-lessons/${encodeURIComponent(id)}/update`,
      { method: 'POST', body: JSON.stringify(body) },
      SkillLessonSchema,
    ),

  adminSkillLessonActivate: (id: string): Promise<SkillLesson> =>
    request(
      `/api/admin/skill-lessons/${encodeURIComponent(id)}/activate`,
      { method: 'POST' },
      SkillLessonSchema,
    ),

  adminSkillLessonReject: (id: string): Promise<SkillLesson> =>
    request(
      `/api/admin/skill-lessons/${encodeURIComponent(id)}/reject`,
      { method: 'POST' },
      SkillLessonSchema,
    ),

  adminSkillLessonArchive: (id: string): Promise<SkillLesson> =>
    request(
      `/api/admin/skill-lessons/${encodeURIComponent(id)}/archive`,
      { method: 'POST' },
      SkillLessonSchema,
    ),

  adminSkillLessonSuggest: (id: string): Promise<SkillLesson> =>
    request(
      `/api/admin/skill-lessons/${encodeURIComponent(id)}/suggest`,
      { method: 'POST' },
      SkillLessonSchema,
    ),

  adminSkillLessonPendingCount: (): Promise<SkillLessonPendingCount> =>
    request(
      '/api/admin/skill-lessons/pending-count',
      { method: 'GET' },
      SkillLessonPendingCountSchema,
    ),

  // ── LLM API Relay ────────────────────────────────────────────────
  adminApiKeysList: (scope: ApiKeyScope): Promise<ApiKeyList> =>
    request(`/api/admin/api-keys?scope=${scope}`, { method: 'GET' }, ApiKeyListSchema),

  adminApiKeyCreate: (body: CreateApiKeyRequest): Promise<ApiKeyWithSecret> =>
    request(
      '/api/admin/api-keys',
      { method: 'POST', body: JSON.stringify(body) },
      ApiKeyWithSecretSchema,
    ),

  adminApiKeyRevoke: (id: string): Promise<{ ok: boolean }> =>
    request(`/api/admin/api-keys/${encodeURIComponent(id)}/revoke`, { method: 'POST' }, OkSchema),

  adminApiKeyDelete: (id: string): Promise<{ ok: boolean }> =>
    request(`/api/admin/api-keys/${encodeURIComponent(id)}/delete`, { method: 'POST' }, OkSchema),

  adminApiKeysUsage: (query: ApiKeyUsageQuery): Promise<ApiKeyUsageList> => {
    const params = new URLSearchParams();
    if (query.keyId) params.set('keyId', query.keyId);
    if (query.userEmail) params.set('userEmail', query.userEmail);
    if (query.statusCode !== undefined) params.set('statusCode', String(query.statusCode));
    if (query.from) params.set('from', query.from);
    if (query.to) params.set('to', query.to);
    if (query.cursor) params.set('cursor', query.cursor);
    if (query.limit) params.set('limit', String(query.limit));
    const qs = params.toString();
    return request(
      `/api/admin/api-keys/usage${qs ? `?${qs}` : ''}`,
      { method: 'GET' },
      ApiKeyUsageListSchema,
    );
  },

  adminApiKeysSettings: (): Promise<ApiKeySettings> =>
    request('/api/admin/api-keys/settings', { method: 'GET' }, ApiKeySettingsSchema),

  adminApiKeysSettingsUpdate: (body: UpdateApiKeySettingsRequest): Promise<ApiKeySettings> =>
    request(
      '/api/admin/api-keys/settings/update',
      { method: 'POST', body: JSON.stringify(body) },
      ApiKeySettingsSchema,
    ),

  apiKeysList: (): Promise<ApiKeyList> =>
    request('/api/api-keys', { method: 'GET' }, ApiKeyListSchema),

  apiKeyCreate: (body: CreateApiKeyRequest): Promise<ApiKeyWithSecret> =>
    request(
      '/api/api-keys',
      { method: 'POST', body: JSON.stringify(body) },
      ApiKeyWithSecretSchema,
    ),

  apiKeyRevoke: (id: string): Promise<{ ok: boolean }> =>
    request(`/api/api-keys/${encodeURIComponent(id)}/revoke`, { method: 'POST' }, OkSchema),

  apiKeyDelete: (id: string): Promise<{ ok: boolean }> =>
    request(`/api/api-keys/${encodeURIComponent(id)}/delete`, { method: 'POST' }, OkSchema),

  apiKeysUsage: (query: Omit<ApiKeyUsageQuery, 'userEmail'>): Promise<ApiKeyUsageList> => {
    const params = new URLSearchParams();
    if (query.keyId) params.set('keyId', query.keyId);
    if (query.statusCode !== undefined) params.set('statusCode', String(query.statusCode));
    if (query.from) params.set('from', query.from);
    if (query.to) params.set('to', query.to);
    if (query.cursor) params.set('cursor', query.cursor);
    if (query.limit) params.set('limit', String(query.limit));
    const qs = params.toString();
    return request(
      `/api/api-keys/usage${qs ? `?${qs}` : ''}`,
      { method: 'GET' },
      ApiKeyUsageListSchema,
    );
  },

  // ============================================================
  // 위키 (조회 전용 v1)
  // ============================================================

  wikiCategories: (): Promise<WikiCategoryList> =>
    request('/api/wikis/categories', { method: 'GET' }, WikiCategoryListSchema),

  wikiIndex: (): Promise<WikiIndex> =>
    request('/api/wikis/index', { method: 'GET' }, WikiIndexSchema),

  wikiGraph: (): Promise<WikiGraphResponse> =>
    request('/api/wikis/graph', { method: 'GET' }, WikiGraphResponseSchema),

  wikiLog: (cursor?: string | null, limit?: number): Promise<WikiLogResponse> => {
    const params = new URLSearchParams();
    if (cursor) params.set('cursor', cursor);
    if (limit) params.set('limit', String(limit));
    const qs = params.toString();
    return request(`/api/wikis/log${qs ? `?${qs}` : ''}`, { method: 'GET' }, WikiLogResponseSchema);
  },

  wikiPages: (query?: {
    category?: string;
    q?: string;
    cursor?: string;
    limit?: number;
  }): Promise<WikiPageList> => {
    const params = new URLSearchParams();
    if (query?.category) params.set('category', query.category);
    if (query?.q) params.set('q', query.q);
    if (query?.cursor) params.set('cursor', query.cursor);
    if (query?.limit) params.set('limit', String(query.limit));
    const qs = params.toString();
    return request(`/api/wikis/pages${qs ? `?${qs}` : ''}`, { method: 'GET' }, WikiPageListSchema);
  },

  wikiPage: (slug: string): Promise<WikiPage> =>
    request(`/api/wikis/pages/${encodeURIComponent(slug)}`, { method: 'GET' }, WikiPageSchema),

  wikiSimilarPages: (slug: string, limit = 5): Promise<WikiSimilarPagesResponse> =>
    request(
      `/api/wikis/pages/${encodeURIComponent(slug)}/similar?limit=${limit}`,
      { method: 'GET' },
      WikiSimilarPagesResponseSchema,
    ),

  wikiSearch: (
    q: string,
    opts?: { category?: string; limit?: number },
  ): Promise<SearchWikiResponse> => {
    const params = new URLSearchParams({ q });
    if (opts?.category) params.set('category', opts.category);
    if (opts?.limit) params.set('limit', String(opts.limit));
    return request(
      `/api/wikis/search?${params.toString()}`,
      { method: 'GET' },
      SearchWikiResponseSchema,
    );
  },

  wikiDocuments: (): Promise<WikiDocumentList> =>
    request('/api/wikis/documents', { method: 'GET' }, WikiDocumentListSchema),

  wikiDocument: (id: string): Promise<WikiDocumentDetail> =>
    request(
      `/api/wikis/documents/${encodeURIComponent(id)}`,
      { method: 'GET' },
      WikiDocumentDetailSchema,
    ),

  wikiDocumentDownloadUrl: (id: string): string =>
    `/api/wikis/documents/${encodeURIComponent(id)}/download`,

  wikiUpload: async (file: File, categorySlug: string | null): Promise<WikiDocument> => {
    const form = new FormData();
    if (categorySlug) form.append('categorySlug', categorySlug);
    form.append('file', file);
    const res = await fetch('/api/wikis/documents/upload', {
      method: 'POST',
      credentials: 'same-origin',
      body: form,
      headers: { 'X-Innermate-Client': 'web' },
    });
    if (!res.ok) {
      const text = await res.text();
      let parsed: unknown;
      try {
        parsed = JSON.parse(text);
      } catch {
        parsed = null;
      }
      const errParsed = ApiErrorSchema.safeParse(parsed);
      if (errParsed.success) {
        throw new ApiError(res.status, errParsed.data.error.code, errParsed.data.error.message);
      }
      throw new ApiError(res.status, 'UPLOAD_FAILED', text || res.statusText);
    }
    const json = await res.json();
    return WikiDocumentSchema.parse((json as { document: unknown }).document);
  },

  wikiDocumentRedigest: (id: string): Promise<{ ok: boolean }> =>
    request(
      `/api/wikis/documents/${encodeURIComponent(id)}/redigest`,
      { method: 'POST' },
      z.object({ ok: z.boolean() }),
    ),

  wikiUploadFromText: (body: {
    title: string;
    categorySlug: string | null;
    rawText: string;
    mode: 'auto-cleanup' | 'as-is';
  }): Promise<WikiDocument> =>
    request(
      '/api/wikis/documents/from-text',
      { method: 'POST', body: JSON.stringify(body) },
      z.object({ document: WikiDocumentSchema }),
    ).then((r) => r.document),

  wikiDocumentReprocess: (id: string): Promise<{ ok: boolean }> =>
    request(
      `/api/wikis/documents/${encodeURIComponent(id)}/reprocess`,
      { method: 'POST' },
      OkSchema,
    ),

  wikiDocumentDelete: (id: string): Promise<{ ok: boolean }> =>
    request(`/api/wikis/documents/${encodeURIComponent(id)}/delete`, { method: 'POST' }, OkSchema),

  wikiDocumentRestore: (id: string): Promise<{ ok: boolean }> =>
    request(`/api/wikis/documents/${encodeURIComponent(id)}/restore`, { method: 'POST' }, OkSchema),

  // ============================================================
  // 위키 admin
  // ============================================================

  adminWikiRuntimeStatus: (): Promise<WikiRuntimeReport> =>
    request('/api/admin/wikis/runtime-status', { method: 'GET' }, WikiRuntimeReportSchema),

  adminWikiRuntimeRefresh: (): Promise<WikiRuntimeReport> =>
    request('/api/admin/wikis/runtime-status/refresh', { method: 'POST' }, WikiRuntimeReportSchema),

  adminWikiConfig: (): Promise<WikiConfig> =>
    request('/api/admin/wikis/config', { method: 'GET' }, WikiConfigSchema),

  adminWikiConfigUpdate: (body: UpdateWikiConfigRequest): Promise<WikiConfig> =>
    request(
      '/api/admin/wikis/config/update',
      { method: 'POST', body: JSON.stringify(body) },
      WikiConfigSchema,
    ),

  adminWikiConfigResetPrompts: (): Promise<WikiConfig> =>
    request('/api/admin/wikis/config/reset-prompts', { method: 'POST' }, WikiConfigSchema),

  adminWikiCategoriesList: (): Promise<WikiCategoryList> =>
    request('/api/admin/wikis/categories', { method: 'GET' }, WikiCategoryListSchema),

  adminWikiCategoryCreate: (body: CreateWikiCategoryRequest): Promise<WikiCategory> =>
    request(
      '/api/admin/wikis/categories',
      { method: 'POST', body: JSON.stringify(body) },
      WikiCategorySchema,
    ),

  adminWikiCategoryUpdate: (id: string, body: UpdateWikiCategoryRequest): Promise<WikiCategory> =>
    request(
      `/api/admin/wikis/categories/${encodeURIComponent(id)}/update`,
      { method: 'POST', body: JSON.stringify(body) },
      WikiCategorySchema,
    ),

  adminWikiCategoryDelete: (id: string): Promise<{ ok: boolean }> =>
    request(
      `/api/admin/wikis/categories/${encodeURIComponent(id)}/delete`,
      { method: 'POST' },
      OkSchema,
    ),

  adminWikiCategoriesReorder: (orderedIds: string[]): Promise<{ ok: boolean }> =>
    request(
      '/api/admin/wikis/categories/reorder',
      { method: 'POST', body: JSON.stringify({ orderedIds }) },
      OkSchema,
    ),

  adminWikiDocuments: (params?: {
    externalOnly?: boolean;
    offset?: number;
    limit?: number;
    q?: string;
    status?: 'archived' | 'active';
  }): Promise<WikiDocumentList> => {
    const qs = new URLSearchParams();
    if (params?.externalOnly) qs.set('externalOnly', 'true');
    if (params?.offset) qs.set('offset', String(params.offset));
    if (params?.limit) qs.set('limit', String(params.limit));
    if (params?.q?.trim()) qs.set('q', params.q.trim());
    if (params?.status) qs.set('status', params.status);
    const qsStr = qs.toString();
    return request(
      `/api/admin/wikis/documents${qsStr ? `?${qsStr}` : ''}`,
      { method: 'GET' },
      WikiDocumentListSchema,
    );
  },

  adminWikiDocumentImageDelete: (
    docId: string,
    filename: string,
  ): Promise<{ ok: boolean; dbRowsDeleted: number }> =>
    request(
      `/api/admin/wikis/documents/${encodeURIComponent(docId)}/images/${encodeURIComponent(filename)}/delete`,
      { method: 'POST' },
      z.object({ ok: z.boolean(), dbRowsDeleted: z.number().int() }),
    ),

  adminWikiPages: (): Promise<WikiPageList> =>
    request('/api/admin/wikis/pages', { method: 'GET' }, WikiPageListSchema),

  adminWikiPageUpdate: (
    slug: string,
    body: UpdateWikiPageRequest,
  ): Promise<{ ok: boolean; slug: string; action: 'created' | 'updated' }> =>
    request(
      `/api/admin/wikis/pages/${encodeURIComponent(slug)}/update`,
      { method: 'POST', body: JSON.stringify(body) },
      z.object({
        ok: z.boolean(),
        slug: z.string(),
        action: z.enum(['created', 'updated']),
      }),
    ),

  adminWikiPageDelete: (slug: string, reason: string): Promise<{ ok: boolean }> =>
    request(
      `/api/admin/wikis/pages/${encodeURIComponent(slug)}/delete`,
      { method: 'POST', body: JSON.stringify({ reason }) },
      OkSchema,
    ),

  adminWikiPageRestore: (slug: string): Promise<{ ok: boolean; alreadyActive?: boolean }> =>
    request(
      `/api/admin/wikis/pages/${encodeURIComponent(slug)}/restore`,
      { method: 'POST' },
      z.object({ ok: z.boolean(), alreadyActive: z.boolean().optional() }),
    ),

  adminWikiBrokenBacklinks: (): Promise<BrokenBacklinkScan> =>
    request('/api/admin/wikis/broken-backlinks', { method: 'GET' }, BrokenBacklinkScanSchema),

  adminWikiBrokenBacklinksCleanup: (): Promise<BrokenBacklinkCleanup> =>
    request(
      '/api/admin/wikis/broken-backlinks/cleanup',
      { method: 'POST' },
      BrokenBacklinkCleanupSchema,
    ),

  adminWikiDeadSourceLinks: (): Promise<DeadSourceLinkScan> =>
    request('/api/admin/wikis/dead-source-links', { method: 'GET' }, DeadSourceLinkScanSchema),

  adminWikiDeadSourceLinksCleanup: (): Promise<DeadSourceLinkCleanup> =>
    request(
      '/api/admin/wikis/dead-source-links/cleanup',
      { method: 'POST' },
      DeadSourceLinkCleanupSchema,
    ),

  adminWikiHealthCheckRun: (): Promise<{ ok: boolean }> =>
    request('/api/admin/wikis/health-check/run', { method: 'POST' }, OkSchema),

  adminWikiHealthCheckRunCategory: (categorySlug: string): Promise<{ ok: boolean }> =>
    request(
      `/api/admin/wikis/health-check/run/${encodeURIComponent(categorySlug)}`,
      { method: 'POST' },
      OkSchema,
    ),

  adminWikiHealthCheckRuns: (): Promise<{
    runs: Array<{
      id: string;
      status: 'done' | 'failed';
      actorUserId: string | null;
      createdAt: string;
      meta: Record<string, unknown>;
    }>;
  }> =>
    request(
      '/api/admin/wikis/health-check/runs',
      { method: 'GET' },
      z.object({
        runs: z.array(
          z.object({
            id: z.string(),
            status: z.enum(['done', 'failed']),
            actorUserId: z.string().nullable(),
            createdAt: z.string(),
            meta: z.record(z.unknown()),
          }),
        ),
      }),
    ),

  adminWikiGraphStats: (): Promise<WikiGraphStats> =>
    request('/api/admin/wikis/graph-stats', { method: 'GET' }, WikiGraphStatsSchema),

  adminWikiRegenerateHubs: (): Promise<WikiHubsRegenerateResponse> =>
    request(
      '/api/admin/wikis/regenerate-hubs',
      { method: 'POST' },
      WikiHubsRegenerateResponseSchema,
    ),

  adminWikiCurateHub: (categorySlug: string): Promise<WikiHubCurateQueuedResponse> =>
    request(
      `/api/admin/wikis/curate-hub/${encodeURIComponent(categorySlug)}`,
      { method: 'POST' },
      WikiHubCurateQueuedResponseSchema,
    ),

  adminWikiCurateAllHubs: (): Promise<WikiHubCurateQueuedResponse> =>
    request(
      '/api/admin/wikis/curate-all-hubs',
      { method: 'POST' },
      WikiHubCurateQueuedResponseSchema,
    ),

  adminWikiReembedAll: (): Promise<WikiReembedAllResponse> =>
    request('/api/admin/wikis/reembed-all', { method: 'POST' }, WikiReembedAllResponseSchema),

  adminWikiBackfillMissingEmbeddings: (): Promise<WikiReembedAllResponse> =>
    request(
      '/api/admin/wikis/embeddings/backfill-missing',
      { method: 'POST' },
      WikiReembedAllResponseSchema,
    ),

  adminWikiReingestAll: (): Promise<WikiReingestStartResponse> =>
    request('/api/admin/wikis/reingest-all', { method: 'POST' }, WikiReingestStartResponseSchema),

  adminWikiReingestStatus: (): Promise<WikiReingestStatus> =>
    request('/api/admin/wikis/reingest-status', { method: 'GET' }, WikiReingestStatusSchema),

  adminWikiExternalSyncLogs: (params?: {
    cursor?: string;
    limit?: number;
    status?: 'success' | 'failed';
    q?: string;
  }): Promise<WikiExternalSyncLogList> => {
    const qs = new URLSearchParams();
    if (params?.cursor) qs.set('cursor', params.cursor);
    if (params?.limit) qs.set('limit', String(params.limit));
    if (params?.status) qs.set('status', params.status);
    if (params?.q?.trim()) qs.set('q', params.q.trim());
    const path = `/api/admin/wikis/external-sync-logs${qs.toString() ? `?${qs}` : ''}`;
    return request(path, { method: 'GET' }, WikiExternalSyncLogListSchema);
  },

  adminWikiEmbeddingsByEndpoint: (): Promise<WikiEmbeddingsByEndpoint> =>
    request(
      '/api/admin/wikis/embeddings/by-endpoint',
      { method: 'GET' },
      WikiEmbeddingsByEndpointSchema,
    ),

  adminWikiReconcileLinks: (): Promise<{
    removed: number;
    inserted: number;
    brokenLinks: number;
  }> =>
    request(
      '/api/admin/wikis/reconcile-links',
      { method: 'POST' },
      z.object({
        removed: z.number().int(),
        inserted: z.number().int(),
        brokenLinks: z.number().int(),
      }),
    ),

  // ── 슬라이드 ─────────────────────────────────────────────────────
  slidesList: (): Promise<SlideListResponse> =>
    request('/api/slides', { method: 'GET' }, SlideListResponseSchema),

  slideGet: (id: string): Promise<Slide> =>
    request(`/api/slides/${encodeURIComponent(id)}`, { method: 'GET' }, SlideSchema),

  slideCreate: (body: CreateSlideRequest = {}): Promise<Slide> =>
    request('/api/slides', { method: 'POST', body: JSON.stringify(body) }, SlideSchema),

  slideRename: (id: string, body: RenameSlideRequest): Promise<Slide> =>
    request(
      `/api/slides/${encodeURIComponent(id)}/rename`,
      { method: 'POST', body: JSON.stringify(body) },
      SlideSchema,
    ),

  slideFavorite: (id: string, body: FavoriteSlideRequest): Promise<Slide> =>
    request(
      `/api/slides/${encodeURIComponent(id)}/favorite`,
      { method: 'POST', body: JSON.stringify(body) },
      SlideSchema,
    ),

  slideDelete: (id: string): Promise<{ ok: boolean }> =>
    request(`/api/slides/${encodeURIComponent(id)}/delete`, { method: 'POST' }, OkSchema),

  slideDuplicate: (id: string): Promise<Slide> =>
    request(`/api/slides/${encodeURIComponent(id)}/duplicate`, { method: 'POST' }, SlideSchema),

  slideSetDesign: (id: string, body: SetSlideDesignRequest): Promise<Slide> =>
    request(
      `/api/slides/${encodeURIComponent(id)}/design`,
      { method: 'POST', body: JSON.stringify(body) },
      SlideSchema,
    ),

  slideCreatePage: (id: string, body: CreateSlidePageRequest): Promise<SlidePage> =>
    request(
      `/api/slides/${encodeURIComponent(id)}/pages`,
      { method: 'POST', body: JSON.stringify(body) },
      SlidePageSchema,
    ),

  slideUpdatePage: (id: string, pid: string, body: UpdateSlidePageRequest): Promise<SlidePage> =>
    request(
      `/api/slides/${encodeURIComponent(id)}/pages/${encodeURIComponent(pid)}/update`,
      { method: 'POST', body: JSON.stringify(body) },
      SlidePageSchema,
    ),

  slideDeletePage: (id: string, pid: string): Promise<{ ok: boolean }> =>
    request(
      `/api/slides/${encodeURIComponent(id)}/pages/${encodeURIComponent(pid)}/delete`,
      { method: 'POST' },
      OkSchema,
    ),

  slideReorderPages: (id: string, body: ReorderSlidePagesRequest): Promise<{ ok: boolean }> =>
    request(
      `/api/slides/${encodeURIComponent(id)}/pages/reorder`,
      { method: 'POST', body: JSON.stringify(body) },
      OkSchema,
    ),

  slideAssets: (id: string): Promise<SlideAssetListResponse> =>
    request(
      `/api/slides/${encodeURIComponent(id)}/assets`,
      { method: 'GET' },
      SlideAssetListResponseSchema,
    ),

  slideUploadAsset: async (id: string, file: File): Promise<SlideAsset> => {
    const fd = new FormData();
    fd.append('file', file, file.name);
    const res = await fetch(`/api/slides/${encodeURIComponent(id)}/assets`, {
      method: 'POST',
      body: fd,
      credentials: 'include',
    });
    const text = await res.text();
    const json = text ? JSON.parse(text) : null;
    if (!res.ok) {
      const parsed = ApiErrorSchema.safeParse(json);
      if (parsed.success) {
        throw new ApiError(
          res.status,
          parsed.data.error.code,
          parsed.data.error.message,
          parsed.data.error.details,
        );
      }
      throw new ApiError(res.status, 'INTERNAL', `자산 업로드 실패 (${res.status})`);
    }
    return SlideAssetSchema.parse(json);
  },

  slideDeleteAsset: (id: string, aid: string): Promise<{ ok: boolean }> =>
    request(
      `/api/slides/${encodeURIComponent(id)}/assets/${encodeURIComponent(aid)}/delete`,
      { method: 'POST' },
      OkSchema,
    ),

  slidePageVersions: (id: string, pid: string): Promise<SlidePageVersionListResponse> =>
    request(
      `/api/slides/${encodeURIComponent(id)}/pages/${encodeURIComponent(pid)}/versions`,
      { method: 'GET' },
      SlidePageVersionListResponseSchema,
    ),

  slideRestorePageVersion: (id: string, pid: string, vid: string): Promise<SlidePage> =>
    request(
      `/api/slides/${encodeURIComponent(id)}/pages/${encodeURIComponent(pid)}/versions/${encodeURIComponent(vid)}/restore`,
      { method: 'POST' },
      SlidePageSchema,
    ),

  // ── 슬라이드 admin ──────────────────────────────────────────────
  adminSlidesConfig: (): Promise<SlidesConfig> =>
    request('/api/admin/slides/config', { method: 'GET' }, SlidesConfigSchema),

  adminSlidesConfigUpdate: (body: UpdateSlidesConfigRequest): Promise<SlidesConfig> =>
    request(
      '/api/admin/slides/config/update',
      { method: 'POST', body: JSON.stringify(body) },
      SlidesConfigSchema,
    ),

  adminSlidesConfigResetPrompts: (): Promise<SlidesConfig> =>
    request('/api/admin/slides/config/reset-prompts', { method: 'POST' }, SlidesConfigSchema),

  // ── 사용자 동적 항목 ───────────────────────────────────────────────
  adminUserAttributesList: (): Promise<UserAttributeDefinitionList> =>
    request('/api/admin/user-attributes', { method: 'GET' }, UserAttributeDefinitionListSchema),

  adminCreateUserAttribute: (body: CreateUserAttributeRequest): Promise<UserAttributeDefinition> =>
    request(
      '/api/admin/user-attributes',
      { method: 'POST', body: JSON.stringify(body) },
      UserAttributeDefinitionSchema,
    ),

  adminUpdateUserAttribute: (
    id: string,
    body: UpdateUserAttributeRequest,
  ): Promise<UserAttributeDefinition> =>
    request(
      `/api/admin/user-attributes/${encodeURIComponent(id)}/update`,
      { method: 'POST', body: JSON.stringify(body) },
      UserAttributeDefinitionSchema,
    ),

  adminDeleteUserAttribute: (id: string): Promise<null> =>
    request(
      `/api/admin/user-attributes/${encodeURIComponent(id)}/delete`,
      { method: 'POST' },
      z.null(),
    ),

  adminReorderUserAttributes: (ids: string[]): Promise<UserAttributeDefinitionList> =>
    request(
      '/api/admin/user-attributes/reorder',
      { method: 'POST', body: JSON.stringify({ ids }) },
      UserAttributeDefinitionListSchema,
    ),

  // ── 데이터소스 테이블 권한 룰 체인 ─────────────────────────────────
  adminScopeRulesList: (dataSourceId: string, tableId: string): Promise<ScopeRuleList> =>
    request(
      `/api/admin/data-sources/${encodeURIComponent(dataSourceId)}/tables/${encodeURIComponent(tableId)}/scope-rules`,
      { method: 'GET' },
      ScopeRuleListSchema,
    ),

  adminCreateScopeRule: (
    dataSourceId: string,
    tableId: string,
    body: CreateScopeRuleRequest,
  ): Promise<ScopeRule> =>
    request(
      `/api/admin/data-sources/${encodeURIComponent(dataSourceId)}/tables/${encodeURIComponent(tableId)}/scope-rules`,
      { method: 'POST', body: JSON.stringify(body) },
      ScopeRuleSchema,
    ),

  adminUpdateScopeRule: (
    dataSourceId: string,
    tableId: string,
    ruleId: string,
    body: UpdateScopeRuleRequest,
  ): Promise<ScopeRule> =>
    request(
      `/api/admin/data-sources/${encodeURIComponent(dataSourceId)}/tables/${encodeURIComponent(tableId)}/scope-rules/${encodeURIComponent(ruleId)}/update`,
      { method: 'POST', body: JSON.stringify(body) },
      ScopeRuleSchema,
    ),

  adminDeleteScopeRule: (dataSourceId: string, tableId: string, ruleId: string): Promise<null> =>
    request(
      `/api/admin/data-sources/${encodeURIComponent(dataSourceId)}/tables/${encodeURIComponent(tableId)}/scope-rules/${encodeURIComponent(ruleId)}/delete`,
      { method: 'POST' },
      z.null(),
    ),

  adminReorderScopeRules: (
    dataSourceId: string,
    tableId: string,
    ids: string[],
  ): Promise<ScopeRuleList> =>
    request(
      `/api/admin/data-sources/${encodeURIComponent(dataSourceId)}/tables/${encodeURIComponent(tableId)}/scope-rules/reorder`,
      { method: 'POST', body: JSON.stringify({ ids }) },
      ScopeRuleListSchema,
    ),

  // ── 사용자 동기화 ──────────────────────────────────────────────────
  adminUserSyncGet: (): Promise<UserSyncConfigResponse> =>
    request('/api/admin/user-sync', { method: 'GET' }, UserSyncConfigResponseSchema),

  adminUserSyncSave: (body: UserSyncConfig): Promise<UserSyncConfigResponse> =>
    request(
      '/api/admin/user-sync',
      { method: 'POST', body: JSON.stringify(body) },
      UserSyncConfigResponseSchema,
    ),

  adminUserSyncPreview: (body: UserSyncConfig): Promise<UserSyncPreviewResponse> =>
    request(
      '/api/admin/user-sync/preview',
      { method: 'POST', body: JSON.stringify(body) },
      UserSyncPreviewResponseSchema,
    ),

  adminUserSyncRun: (): Promise<RunUserSyncResponse> =>
    request('/api/admin/user-sync/run', { method: 'POST' }, RunUserSyncResponseSchema),

  adminUserSyncRuns: (): Promise<UserSyncRunList> =>
    request('/api/admin/user-sync/runs', { method: 'GET' }, UserSyncRunListSchema),

  // ── STT (Web Speech API 폴백) ────────────────────────────────────
  sttCapabilities: (): Promise<SttCapabilities> =>
    request('/api/stt/capabilities', { method: 'GET' }, SttCapabilitiesSchema),

  sttTranscribe: async (audio: Blob, lang?: string): Promise<SttTranscribeResponse> => {
    const fd = new FormData();
    fd.append('audio', audio, 'audio.webm');
    if (lang) fd.append('lang', lang);
    const res = await fetch('/api/stt/transcribe', {
      method: 'POST',
      body: fd,
      credentials: 'include',
    });
    const text = await res.text();
    const json = text ? JSON.parse(text) : null;
    if (!res.ok) {
      const parsed = ApiErrorSchema.safeParse(json);
      if (parsed.success) {
        throw new ApiError(
          res.status,
          parsed.data.error.code,
          parsed.data.error.message,
          parsed.data.error.details,
        );
      }
      throw new ApiError(res.status, 'INTERNAL', `요청 실패 (${res.status})`);
    }
    return SttTranscribeResponseSchema.parse(json);
  },

  // ── 리소스 사용 현황 ─────────────────────────────────────────────
  adminListResourceHosts: (): Promise<ResourceHostList> =>
    request('/api/admin/resource-hosts', { method: 'GET' }, ResourceHostListSchema),

  adminCreateResourceHost: (body: CreateResourceHostRequest): Promise<ResourceHost> =>
    request(
      '/api/admin/resource-hosts',
      { method: 'POST', body: JSON.stringify(body) },
      ResourceHostSchema,
    ),

  adminUpdateResourceHost: (id: string, body: UpdateResourceHostRequest): Promise<ResourceHost> =>
    request(
      `/api/admin/resource-hosts/${encodeURIComponent(id)}/update`,
      { method: 'POST', body: JSON.stringify(body) },
      ResourceHostSchema,
    ),

  adminDeleteResourceHost: (id: string): Promise<null> =>
    request(
      `/api/admin/resource-hosts/${encodeURIComponent(id)}/delete`,
      { method: 'POST' },
      z.null(),
    ),

  adminTestResourceHostConnection: (
    body: TestResourceHostConnectionRequest,
  ): Promise<TestResourceHostConnectionResponse> =>
    request(
      '/api/admin/resource-hosts/test-connection',
      { method: 'POST', body: JSON.stringify(body) },
      TestResourceHostConnectionResponseSchema,
    ),

  adminTestResourceHostConnectionById: (id: string): Promise<TestResourceHostConnectionResponse> =>
    request(
      `/api/admin/resource-hosts/${encodeURIComponent(id)}/test-connection`,
      { method: 'POST' },
      TestResourceHostConnectionResponseSchema,
    ),

  adminGetResourceMetricsLatest: (hostId: string): Promise<ResourceMetricsLatestResponse> =>
    request(
      `/api/admin/resource-metrics/latest?hostId=${encodeURIComponent(hostId)}`,
      { method: 'GET' },
      ResourceMetricsLatestResponseSchema,
    ),

  adminGetResourceMetricsHistory: (
    hostId: string,
    windowSec: number,
  ): Promise<ResourceMetricsHistoryResponse> =>
    request(
      `/api/admin/resource-metrics/history?hostId=${encodeURIComponent(hostId)}&windowSec=${windowSec}`,
      { method: 'GET' },
      ResourceMetricsHistoryResponseSchema,
    ),

  // ── 기간별 리소스 메트릭 (분 단위 적재 기반) ────────────────────
  adminGetResourceMetricsRangeStatistics: (
    hostId: string,
    window: ResourceMetricsRangeWindow,
  ): Promise<ResourceMetricsRangeStatisticsResponse> =>
    request(
      `/api/admin/resource-metrics/range/statistics?hostId=${encodeURIComponent(hostId)}&window=${window}`,
      { method: 'GET' },
      ResourceMetricsRangeStatisticsResponseSchema,
    ),

  adminGetResourceMetricsRangeTimeseries: (
    hostId: string,
    window: ResourceMetricsRangeWindow,
  ): Promise<ResourceMetricsRangeTimeseriesResponse> =>
    request(
      `/api/admin/resource-metrics/range/timeseries?hostId=${encodeURIComponent(hostId)}&window=${window}`,
      { method: 'GET' },
      ResourceMetricsRangeTimeseriesResponseSchema,
    ),

  adminGetResourceMetricsRangeDistribution: (
    hostId: string,
    window: ResourceMetricsRangeWindow,
    metric: ResourceMetricsRangeDistributionMetric,
    gpuIndex?: number,
  ): Promise<ResourceMetricsRangeDistributionResponse> => {
    const params = new URLSearchParams({ hostId, window, metric });
    if (gpuIndex !== undefined) params.set('gpuIndex', String(gpuIndex));
    return request(
      `/api/admin/resource-metrics/range/distribution?${params.toString()}`,
      { method: 'GET' },
      ResourceMetricsRangeDistributionResponseSchema,
    );
  },

  adminGetResourceMetricsRangeHeatmap: (
    hostId: string,
    window: ResourceMetricsRangeWindow,
    metric: ResourceMetricsRangeDistributionMetric,
    gpuIndex?: number,
  ): Promise<ResourceMetricsRangeHeatmapResponse> => {
    const params = new URLSearchParams({ hostId, window, metric });
    if (gpuIndex !== undefined) params.set('gpuIndex', String(gpuIndex));
    return request(
      `/api/admin/resource-metrics/range/heatmap?${params.toString()}`,
      { method: 'GET' },
      ResourceMetricsRangeHeatmapResponseSchema,
    );
  },

  // ---------------------- RBAC (Phase 1) ----------------------

  adminRolesList: (): Promise<RbacRoleListResponse> =>
    request('/api/admin/roles', { method: 'GET' }, RbacRoleListResponseSchema),

  adminRoleGet: (id: string): Promise<RbacRole> =>
    request(`/api/admin/roles/${encodeURIComponent(id)}`, { method: 'GET' }, RbacRoleSchema),

  adminRoleCreate: (body: CreateRbacRoleRequest): Promise<RbacRole> =>
    request('/api/admin/roles', { method: 'POST', body: JSON.stringify(body) }, RbacRoleSchema),

  adminRoleUpdate: (id: string, body: UpdateRbacRoleRequest): Promise<RbacRole> =>
    request(
      `/api/admin/roles/${encodeURIComponent(id)}/update`,
      { method: 'POST', body: JSON.stringify(body) },
      RbacRoleSchema,
    ),

  adminRoleDelete: (id: string): Promise<{ ok: boolean }> =>
    request(
      `/api/admin/roles/${encodeURIComponent(id)}/delete`,
      { method: 'POST' },
      z.object({ ok: z.boolean() }),
    ),

  adminRoleSetSkills: (
    id: string,
    body: SetRoleSkillsRequest,
  ): Promise<{ roleId: string; skillIds: string[] }> =>
    request(
      `/api/admin/roles/${encodeURIComponent(id)}/skills`,
      { method: 'POST', body: JSON.stringify(body) },
      z.object({ roleId: z.string().uuid(), skillIds: z.array(z.string().uuid()) }),
    ),

  /**
   * 자동 부여 룰 미리보기 — body 의 rules 로 즉시 평가 (저장 무관, 편집기 state 직접 전달).
   * 수동 멤버 / 제외는 별도 섹션에서 보여주므로 여기선 룰 매칭만.
   */
  adminRolePreviewMembers: (
    id: string,
    body: {
      rules: Array<{
        attributeKey: string;
        attributeValue: string;
        matchMode: RbacMatchMode;
        negate: boolean;
      }>;
      search?: string;
    },
  ): Promise<{
    roleId: string;
    totalCount: number;
    returnedCount: number;
    members: Array<{
      id: string;
      displayName: string;
      email: string;
      disabledAt: string | null;
    }>;
  }> =>
    request(
      `/api/admin/roles/${encodeURIComponent(id)}/preview-members`,
      { method: 'POST', body: JSON.stringify(body) },
      z.object({
        roleId: z.string().uuid(),
        totalCount: z.number().int().nonnegative(),
        returnedCount: z.number().int().nonnegative(),
        members: z.array(
          z.object({
            id: z.string().uuid(),
            displayName: z.string(),
            email: z.string(),
            disabledAt: z.string().nullable(),
          }),
        ),
      }),
    ),

  /** 그룹의 수동 할당 멤버 상세 정보 — UI 가 멤버를 직접 표시 / 해제. */
  adminRoleGetMembers: (
    id: string,
  ): Promise<{
    roleId: string;
    members: Array<{ id: string; displayName: string; email: string; disabledAt: string | null }>;
  }> =>
    request(
      `/api/admin/roles/${encodeURIComponent(id)}/members`,
      { method: 'GET' },
      z.object({
        roleId: z.string().uuid(),
        members: z.array(
          z.object({
            id: z.string().uuid(),
            displayName: z.string(),
            email: z.string(),
            disabledAt: z.string().nullable(),
          }),
        ),
      }),
    ),

  adminRoleSetMembers: (
    id: string,
    body: SetRoleMembersRequest,
  ): Promise<{ roleId: string; userIds: string[] }> =>
    request(
      `/api/admin/roles/${encodeURIComponent(id)}/members`,
      { method: 'POST', body: JSON.stringify(body) },
      z.object({ roleId: z.string().uuid(), userIds: z.array(z.string().uuid()) }),
    ),

  adminUserSetRoles: (
    userId: string,
    body: SetUserRolesRequest,
  ): Promise<{ userId: string; roleIds: string[] }> =>
    request(
      `/api/admin/users/${encodeURIComponent(userId)}/roles`,
      { method: 'POST', body: JSON.stringify(body) },
      z.object({ userId: z.string().uuid(), roleIds: z.array(z.string().uuid()) }),
    ),

  adminUserGetRoles: (
    userId: string,
  ): Promise<{
    userId: string;
    roles: Array<{ id: string; name: string; enabled: boolean }>;
  }> =>
    request(
      `/api/admin/users/${encodeURIComponent(userId)}/roles`,
      { method: 'GET' },
      z.object({
        userId: z.string().uuid(),
        roles: z.array(z.object({ id: z.string().uuid(), name: z.string(), enabled: z.boolean() })),
      }),
    ),

  adminUserEffectiveSkills: (userId: string): Promise<{ entries: EffectiveSkillEntry[] }> =>
    request(
      `/api/admin/users/${encodeURIComponent(userId)}/effective-skills`,
      { method: 'GET' },
      z.object({ entries: z.array(EffectiveSkillEntrySchema) }),
    ),

  adminSkillRoles: (
    skillId: string,
  ): Promise<{
    skillId: string;
    roles: Array<{ id: string; name: string; description: string | null; enabled: boolean }>;
  }> =>
    request(
      `/api/admin/skills/${encodeURIComponent(skillId)}/roles`,
      { method: 'GET' },
      z.object({
        skillId: z.string().uuid(),
        roles: z.array(
          z.object({
            id: z.string().uuid(),
            name: z.string(),
            description: z.string().nullable(),
            enabled: z.boolean(),
          }),
        ),
      }),
    ),

  // ---------------------- RBAC Phase 2: attribute 룰 ----------------------

  adminRoleGetAttributeGrants: (roleId: string): Promise<RoleAttributeGrantsResponse> =>
    request(
      `/api/admin/roles/${encodeURIComponent(roleId)}/attribute-grants`,
      { method: 'GET' },
      RoleAttributeGrantsResponseSchema,
    ),

  adminRoleSetAttributeGrants: (
    roleId: string,
    body: SetRoleAttributeGrantsRequest,
  ): Promise<RoleAttributeGrantsResponse> =>
    request(
      `/api/admin/roles/${encodeURIComponent(roleId)}/attribute-grants`,
      { method: 'POST', body: JSON.stringify(body) },
      RoleAttributeGrantsResponseSchema,
    ),

  // ---------------------- RBAC Phase 2: exclusion ----------------------

  adminRoleGetExclusions: (
    roleId: string,
  ): Promise<{
    roleId: string;
    exclusions: Array<{
      userId: string;
      displayName: string;
      email: string;
      reason: string | null;
      createdAt: string;
    }>;
  }> =>
    request(
      `/api/admin/roles/${encodeURIComponent(roleId)}/exclusions`,
      { method: 'GET' },
      z.object({
        roleId: z.string().uuid(),
        exclusions: z.array(
          z.object({
            userId: z.string().uuid(),
            displayName: z.string(),
            email: z.string(),
            reason: z.string().nullable(),
            createdAt: z.string(),
          }),
        ),
      }),
    ),

  adminUserGetRoleExclusions: (
    userId: string,
  ): Promise<{
    userId: string;
    exclusions: Array<{
      roleId: string;
      roleName: string;
      reason: string | null;
      createdAt: string;
    }>;
  }> =>
    request(
      `/api/admin/users/${encodeURIComponent(userId)}/role-exclusions`,
      { method: 'GET' },
      z.object({
        userId: z.string().uuid(),
        exclusions: z.array(
          z.object({
            roleId: z.string().uuid(),
            roleName: z.string(),
            reason: z.string().nullable(),
            createdAt: z.string(),
          }),
        ),
      }),
    ),

  adminUserAddRoleExclusion: (
    userId: string,
    body: AddRoleExclusionRequest,
  ): Promise<{ userId: string; roleId: string; reason: string | null }> =>
    request(
      `/api/admin/users/${encodeURIComponent(userId)}/role-exclusions`,
      { method: 'POST', body: JSON.stringify(body) },
      z.object({
        userId: z.string().uuid(),
        roleId: z.string().uuid(),
        reason: z.string().nullable(),
      }),
    ),

  adminUserRemoveRoleExclusion: (userId: string, roleId: string): Promise<{ ok: boolean }> =>
    request(
      `/api/admin/users/${encodeURIComponent(userId)}/role-exclusions/${encodeURIComponent(roleId)}/delete`,
      { method: 'POST' },
      z.object({ ok: z.boolean() }),
    ),

  /** 전사 attribute 룰 미리보기 + 룰별 매칭 사용자 수. */
  adminPermissionsAttributeRules: (): Promise<{
    rules: Array<{
      roleId: string;
      roleName: string;
      roleEnabled: boolean;
      skillCount: number;
      attributeKey: string;
      attributeValue: string;
      matchMode: RbacMatchMode;
      negate: boolean;
      matchCount: number;
    }>;
  }> =>
    request(
      '/api/admin/permissions/attribute-rules',
      { method: 'GET' },
      z.object({
        rules: z.array(
          z.object({
            roleId: z.string().uuid(),
            roleName: z.string(),
            roleEnabled: z.boolean(),
            skillCount: z.number().int().nonnegative(),
            attributeKey: z.string(),
            attributeValue: z.string(),
            matchMode: RbacMatchModeSchema,
            negate: z.boolean(),
            matchCount: z.number().int().nonnegative(),
          }),
        ),
      }),
    ),

  // ──────────────────────────────────────────────────────────────────
  // 영속 대시보드 — chat artifact 의 dashboard 버전을 "저장" 누른 결과.
  // 좌측 사이드바 목록 / 공유 view 페이지 / 분석설계 다이얼로그가 호출.
  // ──────────────────────────────────────────────────────────────────

  dashboardListMine: (): Promise<DashboardSummaryList> =>
    request('/api/dashboards/mine', { method: 'GET' }, DashboardSummaryListSchema),

  /** 공유받은 대시보드 — owner 가 아니면서 visibility=public 이거나 같은 그룹원으로 공유된 항목. */
  dashboardListShared: (): Promise<SharedDashboardSummaryList> =>
    request('/api/dashboards/shared', { method: 'GET' }, SharedDashboardSummaryListSchema),

  dashboardGroupOptions: (): Promise<DashboardGroupOptionList> =>
    request('/api/dashboards/groups/mine', { method: 'GET' }, DashboardGroupOptionListSchema),

  dashboardGet: (id: string) =>
    request(
      `/api/dashboards/${encodeURIComponent(id)}`,
      { method: 'GET' },
      DashboardDetailSchema,
    ) as Promise<DashboardDetail>,

  dashboardSave: (body: SaveDashboardRequest): Promise<{ id: string }> =>
    request(
      '/api/dashboards',
      { method: 'POST', body: JSON.stringify(body) },
      z.object({ id: z.string().uuid() }),
    ),

  dashboardRename: (id: string, body: RenameDashboardRequest): Promise<{ ok: boolean }> =>
    request(
      `/api/dashboards/${encodeURIComponent(id)}/rename`,
      { method: 'POST', body: JSON.stringify(body) },
      z.object({ ok: z.boolean() }),
    ),

  /** 공유 현황 (owner 전용) — 일반 접근 권한 + 명시 공유 대상 목록. */
  dashboardShares: (id: string): Promise<DashboardSharesResponse> =>
    request(
      `/api/dashboards/${encodeURIComponent(id)}/shares`,
      { method: 'GET' },
      DashboardSharesResponseSchema,
    ),

  dashboardShare: (id: string, body: ShareDashboardRequest): Promise<{ ok: boolean }> =>
    request(
      `/api/dashboards/${encodeURIComponent(id)}/share`,
      { method: 'POST', body: JSON.stringify(body) },
      z.object({ ok: z.boolean() }),
    ),

  // ── 개인 사용자 그룹 + 디렉터리 검색 ───────────────────────────────
  userGroupsList: (): Promise<UserGroupSummaryList> =>
    request('/api/user-groups', { method: 'GET' }, UserGroupSummaryListSchema),

  userGroupCreate: (body: CreateUserGroupRequest): Promise<UserGroupSummary> =>
    request(
      '/api/user-groups',
      { method: 'POST', body: JSON.stringify(body) },
      UserGroupSummarySchema,
    ),

  userGroupDetail: (id: string): Promise<UserGroupDetail> =>
    request(`/api/user-groups/${encodeURIComponent(id)}`, { method: 'GET' }, UserGroupDetailSchema),

  userGroupRename: (id: string, body: RenameUserGroupRequest): Promise<{ ok: boolean }> =>
    request(
      `/api/user-groups/${encodeURIComponent(id)}/rename`,
      { method: 'POST', body: JSON.stringify(body) },
      z.object({ ok: z.boolean() }),
    ),

  userGroupDelete: (id: string): Promise<null> =>
    request(`/api/user-groups/${encodeURIComponent(id)}/delete`, { method: 'POST' }, z.null()),

  userGroupAddMembers: (id: string, userIds: string[]): Promise<UserGroupDetail> =>
    request(
      `/api/user-groups/${encodeURIComponent(id)}/members/add`,
      { method: 'POST', body: JSON.stringify({ userIds }) },
      UserGroupDetailSchema,
    ),

  userGroupRemoveMembers: (id: string, userIds: string[]): Promise<UserGroupDetail> =>
    request(
      `/api/user-groups/${encodeURIComponent(id)}/members/remove`,
      { method: 'POST', body: JSON.stringify({ userIds }) },
      UserGroupDetailSchema,
    ),

  directorySearch: (q: string): Promise<DirectorySearchResponse> =>
    request(
      `/api/directory/search?q=${encodeURIComponent(q)}`,
      { method: 'GET' },
      DirectorySearchResponseSchema,
    ),

  dashboardSettings: (id: string, body: UpdateDashboardSettingsRequest): Promise<{ ok: boolean }> =>
    request(
      `/api/dashboards/${encodeURIComponent(id)}/settings`,
      { method: 'POST', body: JSON.stringify(body) },
      z.object({ ok: z.boolean() }),
    ),

  dashboardDelete: (id: string): Promise<null> =>
    request(`/api/dashboards/${encodeURIComponent(id)}/delete`, { method: 'POST' }, z.null()),

  dashboardReorder: (body: ReorderDashboardsRequest): Promise<{ ok: boolean }> =>
    request(
      '/api/dashboards/reorder',
      { method: 'POST', body: JSON.stringify(body) },
      z.object({ ok: z.boolean() }),
    ),

  /**
   * iframe 의 위젯 ⋮ 메뉴 편집 결과를 영속화 (fire-and-forget).
   * single source of truth 는 iframe SPEC — 서버는 그대로 replace + zod 검증만.
   */
  dashboardSetSpec: (id: string, body: EditDashboardSpecRequest): Promise<{ ok: boolean }> =>
    request(
      `/api/dashboards/${encodeURIComponent(id)}/spec`,
      { method: 'POST', body: JSON.stringify(body) },
      z.object({ ok: z.boolean() }),
    ),

  /** 분석 패널 — viewer 권한 saved_query 재실행 → 컬럼 프로파일 + 데이터 품질 A~D. */
  dashboardProfile: (id: string): Promise<DashboardProfileResponse> =>
    request(
      `/api/dashboards/${encodeURIComponent(id)}/profile`,
      { method: 'GET' },
      DashboardProfileResponseSchema,
    ),

  /** 단일 widget server-render. iframe 의 client-side mutation (duplicate / change_kind) 이
   *  부모를 매개로 호출해 받은 html+script 로 .ww 안 교체 + chart.js 재초기화. */
  dashboardWidgetRender: (body: WidgetRenderRequest): Promise<WidgetRenderResponse> =>
    request(
      '/api/dashboards/widget-render',
      { method: 'POST', body: JSON.stringify(body) },
      WidgetRenderResponseSchema,
    ),

  /** view 페이지 iframe RPC — chat artifact RPC 와 응답 스키마 동일, owner-only 가드 우회. */
  dashboardRpc: (
    dashboardId: string,
    method: 'runSavedQuery',
    params: unknown,
  ): Promise<ArtifactRpcResponse> =>
    request(
      `/api/dashboards/${encodeURIComponent(dashboardId)}/rpc`,
      { method: 'POST', body: JSON.stringify({ method, params }) },
      ArtifactRpcResponseSchema,
    ),

  responsePromptsTree: (): Promise<ResponsePromptTree> =>
    request('/api/admin/response-prompts', { method: 'GET' }, ResponsePromptTreeSchema),
  responsePromptDetail: (id: string): Promise<ResponsePromptDetail> =>
    request(
      `/api/admin/response-prompts/${encodeURIComponent(id)}`,
      { method: 'GET' },
      ResponsePromptDetailSchema,
    ),
  responsePromptCreate: (body: CreateResponsePromptRequest): Promise<ResponsePromptDetail> =>
    request(
      '/api/admin/response-prompts',
      { method: 'POST', body: JSON.stringify(body) },
      ResponsePromptDetailSchema,
    ),
  responsePromptRename: (id: string, body: RenameResponsePromptRequest): Promise<{ ok: boolean }> =>
    request(
      `/api/admin/response-prompts/${encodeURIComponent(id)}/rename`,
      { method: 'POST', body: JSON.stringify(body) },
      OkSchema,
    ),
  responsePromptMove: (id: string, body: MoveResponsePromptRequest): Promise<{ ok: boolean }> =>
    request(
      `/api/admin/response-prompts/${encodeURIComponent(id)}/move`,
      { method: 'POST', body: JSON.stringify(body) },
      OkSchema,
    ),
  responsePromptSetPreferredEndpoint: (
    id: string,
    endpointId: string | null,
  ): Promise<{ ok: boolean }> =>
    request(
      `/api/admin/response-prompts/${encodeURIComponent(id)}/set-preferred-endpoint`,
      { method: 'POST', body: JSON.stringify({ endpointId }) },
      OkSchema,
    ),
  responsePromptDelete: (id: string): Promise<{ ok: boolean }> =>
    request(
      `/api/admin/response-prompts/${encodeURIComponent(id)}/delete`,
      { method: 'POST' },
      OkSchema,
    ),
  responsePromptDuplicate: (
    id: string,
    body: DuplicateResponsePromptRequest,
  ): Promise<ResponsePromptDetail> =>
    request(
      `/api/admin/response-prompts/${encodeURIComponent(id)}/duplicate`,
      { method: 'POST', body: JSON.stringify(body) },
      ResponsePromptDetailSchema,
    ),
  responsePromptSaveVersion: (
    id: string,
    body: SaveResponsePromptVersionRequest,
  ): Promise<unknown> =>
    request(
      `/api/admin/response-prompts/${encodeURIComponent(id)}/versions`,
      { method: 'POST', body: JSON.stringify(body) },
      z.unknown(),
    ),
  responsePromptActivateVersion: (id: string, versionId: string): Promise<{ ok: boolean }> =>
    request(
      `/api/admin/response-prompts/${encodeURIComponent(id)}/versions/${encodeURIComponent(versionId)}/activate`,
      { method: 'POST' },
      OkSchema,
    ),
  responsePromptUpdateVersionTags: (
    id: string,
    versionId: string,
    body: UpdateResponsePromptVersionTagsRequest,
  ): Promise<{ ok: boolean }> =>
    request(
      `/api/admin/response-prompts/${encodeURIComponent(id)}/versions/${encodeURIComponent(versionId)}/tags`,
      { method: 'POST', body: JSON.stringify(body) },
      OkSchema,
    ),
  responsePromptVariantCreate: (
    id: string,
    body: CreateResponsePromptVariantRequest,
  ): Promise<ResponsePromptVariant> =>
    request(
      `/api/admin/response-prompts/${encodeURIComponent(id)}/variants`,
      { method: 'POST', body: JSON.stringify(body) },
      ResponsePromptVariantSchema,
    ),
  responsePromptVariantRename: (
    id: string,
    variantId: string,
    body: RenameResponsePromptVariantRequest,
  ): Promise<{ ok: boolean }> =>
    request(
      `/api/admin/response-prompts/${encodeURIComponent(id)}/variants/${encodeURIComponent(variantId)}/rename`,
      { method: 'POST', body: JSON.stringify(body) },
      OkSchema,
    ),
  responsePromptVariantDelete: (id: string, variantId: string): Promise<{ ok: boolean }> =>
    request(
      `/api/admin/response-prompts/${encodeURIComponent(id)}/variants/${encodeURIComponent(variantId)}/delete`,
      { method: 'POST' },
      OkSchema,
    ),
  responsePromptRunTest: (
    body: RunResponsePromptTestRequest,
    signal?: AbortSignal,
  ): Promise<RunResponsePromptTestResponse> =>
    request(
      '/api/admin/response-prompts/test',
      { method: 'POST', body: JSON.stringify(body), signal },
      RunResponsePromptTestResponseSchema,
    ),
  responsePromptBulkActiveTags: (
    body: BulkUpdateActiveTagsRequest,
  ): Promise<BulkUpdateActiveTagsResponse> =>
    request(
      '/api/admin/response-prompts/bulk/active-tags',
      { method: 'POST', body: JSON.stringify(body) },
      BulkUpdateActiveTagsResponseSchema,
    ),
  responsePromptExport: (): Promise<ResponsePromptExport> =>
    request('/api/admin/response-prompts/export', { method: 'GET' }, ResponsePromptExportSchema),
  responsePromptExportSelected: (ids: string[]): Promise<ResponsePromptExport> =>
    request(
      '/api/admin/response-prompts/export/selected',
      { method: 'POST', body: JSON.stringify({ ids }) },
      ResponsePromptExportSchema,
    ),
  responsePromptImport: (body: ResponsePromptExport): Promise<ResponsePromptImportResponse> =>
    request(
      '/api/admin/response-prompts/import',
      { method: 'POST', body: JSON.stringify(body) },
      ResponsePromptImportResponseSchema,
    ),
  responsePromptTestCasesList: (id: string): Promise<ResponsePromptTestCaseList> =>
    request(
      `/api/admin/response-prompts/${encodeURIComponent(id)}/test-cases`,
      { method: 'GET' },
      ResponsePromptTestCaseListSchema,
    ),
  responsePromptTestCaseCreate: (
    id: string,
    body: CreateResponsePromptTestCaseRequest,
  ): Promise<ResponsePromptTestCase> =>
    request(
      `/api/admin/response-prompts/${encodeURIComponent(id)}/test-cases`,
      { method: 'POST', body: JSON.stringify(body) },
      ResponsePromptTestCaseSchema,
    ),
  responsePromptTestCaseDelete: (id: string, caseId: string): Promise<{ ok: boolean }> =>
    request(
      `/api/admin/response-prompts/${encodeURIComponent(id)}/test-cases/${encodeURIComponent(caseId)}/delete`,
      { method: 'POST' },
      OkSchema,
    ),
};

export { ApiError };
